/* Alugutter Project Estimator — product data.
   Loaded by sections/Estimating_tool.liquid. Static: variant ids keyed by SKU
   (product code + colour suffix) and the product code/description tables the
   three calculators read. Kept out of the section so the section stays under
   Shopify's 256 KB per-file limit. Vanilla JS, no dependencies. */

/* ============================================================
   SHARED VARIANT ID MAP (combined from all three tools)
   ============================================================ */
const AG_VARIANT_IDS = {
  /* ---- GUTTER: Half Round ---- */
  "GHR1-7016":"31694035615801","GHR1-7021":"31694035681337","GHR1-7022":"31694134706233","GHR1-7035":"31694138736697","GHR1-7036":"31694147846201","GHR1-7037":"31694149713977","GHR1-9005":"31694035583033","GHR1-9006":"31694154104889","GHR1-9010":"31694035648569","GHR1-9016":"31694150991929","GHR1-TB":"31694155776057","GHR1-TBA":"31703851860025",
  "GHR2-7016":"31694164820025","GHR2-7021":"31694164852793","GHR2-7022":"31694164885561","GHR2-7035":"31694164918329","GHR2-7036":"31694164951097","GHR2-7037":"31694164983865","GHR2-9005":"31694164787257","GHR2-9006":"31694165016633","GHR2-9010":"31694165049401","GHR2-9016":"31694165082169","GHR2-TB":"31694164754489","GHR2-TBA":"31703855824953",
  "GHR3-7016":"31697985142841","GHR3-7021":"31697985175609","GHR3-7022":"31697985208377","GHR3-7035":"31697985241145","GHR3-7036":"31697985273913","GHR3-7037":"31697985306681","GHR3-9005":"31697985110073","GHR3-9006":"31697985339449","GHR3-9010":"31697985372217","GHR3-9016":"31697985404985","GHR3-TB":"31697985077305","GHR3-TBA":"31703857823801",
  "GHR4-7016":"31694195458105","GHR4-7021":"31694195490873","GHR4-7022":"31694195523641","GHR4-7035":"31694195556409","GHR4-7036":"31694195589177","GHR4-7037":"31694195621945","GHR4-9005":"31694195425337","GHR4-9006":"31694195654713","GHR4-9010":"31694195687481","GHR4-9016":"31694195720249","GHR4-TB":"31694195392569","GHR4-TBA":"31703859986489",
  "GHR5-7016":"31697949818937","GHR5-7021":"31697949851705","GHR5-7022":"31697949884473","GHR5-7035":"31697949917241","GHR5-7036":"31697949950009","GHR5-7037":"31697949982777","GHR5-9005":"31697949786169","GHR5-9006":"31697950015545","GHR5-9010":"31697950048313","GHR5-9016":"31697950081081","GHR5-TB":"31697949720633","GHR5-TBA":"31703861002297",
  "GHR6-7016":"31698263605305","GHR6-7021":"31698263638073","GHR6-7022":"31698263670841","GHR6-7035":"31698263703609","GHR6-7036":"31698263736377","GHR6-7037":"31698263769145","GHR6-9005":"31698263572537","GHR6-9006":"31698263801913","GHR6-9010":"31698263834681","GHR6-9016":"31698263867449","GHR6-TB":"31698263539769","GHR6-TBA":"31703863164985",
  "GHR7-7016":"31698284609593","GHR7-7021":"31698284642361","GHR7-7022":"31698284707897","GHR7-7035":"31698284740665","GHR7-7036":"31698284773433","GHR7-7037":"31698284806201","GHR7-9005":"31698284576825","GHR7-9006":"31698284838969","GHR7-9010":"31698284871737","GHR7-9016":"31698284904505","GHR7-TB":"31698284544057","GHR7-TBA":"31703864442937",
  "GHR8-7016":"31698287919161","GHR8-7021":"31698287951929","GHR8-7022":"31698287984697","GHR8-7035":"31698288017465","GHR8-7036":"31698288050233","GHR8-7037":"31698288083001","GHR8-9005":"31698287886393","GHR8-9006":"31698288115769","GHR8-9010":"31698288148537","GHR8-9016":"31698288181305","GHR8-TB":"31698287853625","GHR8-TBA":"31703865884729",
  "GHR9-7016":"31698294407225","GHR9-7021":"31698294439993","GHR9-7022":"31698294472761","GHR9-7035":"31698294505529","GHR9-7036":"31698294538297","GHR9-7037":"31698294571065","GHR9-9005":"31698294374457","GHR9-9006":"31698294603833","GHR9-9010":"31698294636601","GHR9-9016":"31698294669369","GHR9-TB":"31698294341689","GHR9-TBA":"31703869521977",
  "GHR10-7016":"31698298044473","GHR10-7021":"31698298077241","GHR10-7022":"31698298110009","GHR10-7035":"31698298142777","GHR10-7036":"31698298175545","GHR10-7037":"31698298208313","GHR10-9005":"31698298011705","GHR10-9006":"31698298241081","GHR10-9010":"31698298273849","GHR10-9016":"31698298306617","GHR10-TB":"31698297978937","GHR10-TBA":"31703852384313",
  "GHR12-7016":"31802902839353","GHR12-7021":"31802902872121","GHR12-7022":"31802902904889","GHR12-7035":"31802902937657","GHR12-7036":"31802902970425","GHR12-7037":"31802903003193","GHR12-9005":"31802902806585","GHR12-9006":"31802903035961","GHR12-9010":"31802903068729","GHR12-9016":"31802903101497","GHR12-TB":"31802902773817","GHR12-TBA":"31802903134265"
};
// Additional variant IDs appended to AG_VARIANT_IDS
Object.assign(AG_VARIANT_IDS, {
  "C175-7016": "31731130761273",
  "C175-7021": "31731130794041",
  "C175-7022": "31731130826809",
  "C175-7035": "31731130859577",
  "C175-7036": "31731130892345",
  "C175-7037": "31731130925113",
  "C175-9005": "31731130728505",
  "C175-9006": "31731130957881",
  "C175-9010": "31731130990649",
  "C175-9016": "31731131023417",
  "C175-TB": "31731130695737",
  "C175-TBA": "31731131056185",
  "C1751-7016": "31734235988025",
  "C1751-7021": "31734236020793",
  "C1751-7022": "31734236053561",
  "C1751-7035": "31734236086329",
  "C1751-7036": "31734236119097",
  "C1751-7037": "31734236151865",
  "C1751-9005": "31734235955257",
  "C1751-9006": "31734236184633",
  "C1751-9010": "31734236217401",
  "C1751-9016": "31734236250169",
  "C1751-TB": "31734235922489",
  "C1751-TBA": "31734236282937",
  "C1752-7016": "31734297722937",
  "C1752-7021": "31734297755705",
  "C1752-7022": "31734297788473",
  "C1752-7035": "31734297821241",
  "C1752-7036": "31734297854009",
  "C1752-7037": "31734297886777",
  "C1752-9005": "31734297690169",
  "C1752-9006": "31734297919545",
  "C1752-9010": "31734297952313",
  "C1752-9016": "31734297985081",
  "C1752-TB": "31734297657401",
  "C1752-TBA": "31734298017849",
  "C1753-7016": "31734302900281",
  "C1753-7021": "31734302933049",
  "C1753-7022": "31734302965817",
  "C1753-7035": "31734302998585",
  "C1753-7036": "31734303031353",
  "C1753-7037": "31734303064121",
  "C1753-9005": "31734302867513",
  "C1753-9006": "31734303096889",
  "C1753-9010": "31734303129657",
  "C1753-9016": "31734303162425",
  "C1753-TB": "31734302834745",
  "C1753-TBA": "31734303195193",
  "C1754-7016": "31734309322809",
  "C1754-7021": "31734309355577",
  "C1754-7022": "31734309388345",
  "C1754-7035": "31734309421113",
  "C1754-7036": "31734309453881",
  "C1754-7037": "31734309486649",
  "C1754-9005": "31734309290041",
  "C1754-9006": "31734309519417",
  "C1754-9010": "31734309552185",
  "C1754-9016": "31734309584953",
  "C1754-TB": "31734309257273",
  "C1754-TBA": "31734309617721",
  "C1755-7016": "31734327345209",
  "C1755-7021": "31734327377977",
  "C1755-7022": "31734327410745",
  "C1755-7035": "31734327443513",
  "C1755-7036": "31734327476281",
  "C1755-7037": "31734327509049",
  "C1755-9005": "31734327312441",
  "C1755-9006": "31734327541817",
  "C1755-9010": "31734327574585",
  "C1755-9016": "31734327607353",
  "C1755-TB": "31734327279673",
  "C1755-TBA": "31734327640121",
  "C240-7016": "31731131154489",
  "C240-7021": "31731131187257",
  "C240-7022": "31731131220025",
  "C240-7035": "31731131252793",
  "C240-7036": "31731131285561",
  "C240-7037": "31731131318329",
  "C240-9005": "31731131121721",
  "C240-9006": "31731131351097",
  "C240-9010": "31731131383865",
  "C240-9016": "31731131416633",
  "C240-TB": "31731131088953",
  "C240-TBA": "31731131449401",
  "C2401-7016": "31734236381241",
  "C2401-7021": "31734236414009",
  "C2401-7022": "31734236446777",
  "C2401-7035": "31734236479545",
  "C2401-7036": "31734236512313",
  "C2401-7037": "31734236545081",
  "C2401-9005": "31734236348473",
  "C2401-9006": "31734236577849",
  "C2401-9010": "31734236610617",
  "C2401-9016": "31734236643385",
  "C2401-TB": "31734236315705",
  "C2401-TBA": "31734236676153",
  "C2402-7016": "31734298116153",
  "C2402-7021": "31734298148921",
  "C2402-7022": "31734298181689",
  "C2402-7035": "31734298214457",
  "C2402-7036": "31734298247225",
  "C2402-7037": "31734298279993",
  "C2402-9005": "31734298083385",
  "C2402-9006": "31734298312761",
  "C2402-9010": "31734298345529",
  "C2402-9016": "31734298378297",
  "C2402-TB": "31734298050617",
  "C2402-TBA": "31734298411065",
  "C2403-7016": "31734303293497",
  "C2403-7021": "31734303326265",
  "C2403-7022": "31734303359033",
  "C2403-7035": "31734303391801",
  "C2403-7036": "31734303424569",
  "C2403-7037": "31734303457337",
  "C2403-9005": "31734303260729",
  "C2403-9006": "31734303490105",
  "C2403-9010": "31734303522873",
  "C2403-9016": "31734303555641",
  "C2403-TB": "31734303227961",
  "C2403-TBA": "31734303588409",
  "C2404-7016": "31734309716025",
  "C2404-7021": "31734309748793",
  "C2404-7022": "31734309781561",
  "C2404-7035": "31734309814329",
  "C2404-7036": "31734309847097",
  "C2404-7037": "31734309879865",
  "C2404-9005": "31734309683257",
  "C2404-9006": "31734309912633",
  "C2404-9010": "31734309945401",
  "C2404-9016": "31734309978169",
  "C2404-TB": "31734309650489",
  "C2404-TBA": "31734310010937",
  "C2405-7016": "31734327738425",
  "C2405-7021": "31734327771193",
  "C2405-7022": "31734327803961",
  "C2405-7035": "31734327836729",
  "C2405-7036": "31734327869497",
  "C2405-7037": "31734327902265",
  "C2405-9005": "31734327705657",
  "C2405-9006": "31734327935033",
  "C2405-9010": "31734327967801",
  "C2405-9016": "31734328000569",
  "C2405-TB": "31734327672889",
  "C2405-TBA": "31734328033337",
  "C300-7016": "31731131547705",
  "C300-7021": "31731131580473",
  "C300-7022": "31731131613241",
  "C300-7035": "31731131646009",
  "C300-7036": "31731131678777",
  "C300-7037": "31731131711545",
  "C300-9005": "31731131514937",
  "C300-9006": "31731131744313",
  "C300-9010": "31731131777081",
  "C300-9016": "31731131809849",
  "C300-TB": "31731131482169",
  "C300-TBA": "31731131842617",
  "C3001-7016": "31734236774457",
  "C3001-7021": "31734236807225",
  "C3001-7022": "31734236839993",
  "C3001-7035": "31734236872761",
  "C3001-7036": "31734236905529",
  "C3001-7037": "31734236938297",
  "C3001-9005": "31734236741689",
  "C3001-9006": "31734236971065",
  "C3001-9010": "31734237003833",
  "C3001-9016": "31734237036601",
  "C3001-TB": "31734236708921",
  "C3001-TBA": "31734237069369",
  "C3002-7016": "31734298509369",
  "C3002-7021": "31734298542137",
  "C3002-7022": "31734298574905",
  "C3002-7035": "31734298607673",
  "C3002-7036": "31734298640441",
  "C3002-7037": "31734298673209",
  "C3002-9005": "31734298476601",
  "C3002-9006": "31734298705977",
  "C3002-9010": "31734298738745",
  "C3002-9016": "31734298771513",
  "C3002-TB": "31734298443833",
  "C3002-TBA": "31734298804281",
  "C3003-7016": "31734303686713",
  "C3003-7021": "31734303719481",
  "C3003-7022": "31734303752249",
  "C3003-7035": "31734303785017",
  "C3003-7036": "31734303817785",
  "C3003-7037": "31734303850553",
  "C3003-9005": "31734303653945",
  "C3003-9006": "31734303883321",
  "C3003-9010": "31734303916089",
  "C3003-9016": "31734303948857",
  "C3003-TB": "31734303621177",
  "C3003-TBA": "31734303981625",
  "C3004-7016": "31734310109241",
  "C3004-7021": "31734310142009",
  "C3004-7022": "31734310174777",
  "C3004-7035": "31734310207545",
  "C3004-7036": "31734310240313",
  "C3004-7037": "31734310273081",
  "C3004-9005": "31734310076473",
  "C3004-9006": "31734310305849",
  "C3004-9010": "31734310338617",
  "C3004-9016": "31734310371385",
  "C3004-TB": "31734310043705",
  "C3004-TBA": "31734310404153",
  "C3005-7016": "31734328131641",
  "C3005-7021": "31734328164409",
  "C3005-7022": "31734328197177",
  "C3005-7035": "31734328229945",
  "C3005-7036": "31734328262713",
  "C3005-7037": "31734328295481",
  "C3005-9005": "31734328098873",
  "C3005-9006": "31734328328249",
  "C3005-9010": "31734328361017",
  "C3005-9016": "31734328393785",
  "C3005-TB": "31734328066105",
  "C3005-TBA": "31734328426553",
  "C360-7016": "31731131940921",
  "C360-7021": "31731131973689",
  "C360-7022": "31731132006457",
  "C360-7035": "31731132039225",
  "C360-7036": "31731132071993",
  "C360-7037": "31731132104761",
  "C360-9005": "31731131908153",
  "C360-9006": "31731132137529",
  "C360-9010": "31731132170297",
  "C360-9016": "31731132203065",
  "C360-TB": "31731131875385",
  "C360-TBA": "31731132235833",
  "C3601-7016": "31734237167673",
  "C3601-7021": "31734237200441",
  "C3601-7022": "31734237233209",
  "C3601-7035": "31734237265977",
  "C3601-7036": "31734237298745",
  "C3601-7037": "31734237331513",
  "C3601-9005": "31734237134905",
  "C3601-9006": "31734237364281",
  "C3601-9010": "31734237397049",
  "C3601-9016": "31734237429817",
  "C3601-TB": "31734237102137",
  "C3601-TBA": "31734237462585",
  "C3602-7016": "31734298902585",
  "C3602-7021": "31734298935353",
  "C3602-7022": "31734298968121",
  "C3602-7035": "31734299000889",
  "C3602-7036": "31734299033657",
  "C3602-7037": "31734299066425",
  "C3602-9005": "31734298869817",
  "C3602-9006": "31734299099193",
  "C3602-9010": "31734299131961",
  "C3602-9016": "31734299164729",
  "C3602-TB": "31734298837049",
  "C3602-TBA": "31734299197497",
  "C3603-7016": "31734304079929",
  "C3603-7021": "31734304112697",
  "C3603-7022": "31734304145465",
  "C3603-7035": "31734304178233",
  "C3603-7036": "31734304211001",
  "C3603-7037": "31734304243769",
  "C3603-9005": "31734304047161",
  "C3603-9006": "31734304276537",
  "C3603-9010": "31734304309305",
  "C3603-9016": "31734304342073",
  "C3603-TB": "31734304014393",
  "C3603-TBA": "31734304374841",
  "C3604-7016": "31734310502457",
  "C3604-7021": "31734310535225",
  "C3604-7022": "31734310567993",
  "C3604-7035": "31734310600761",
  "C3604-7036": "31734310633529",
  "C3604-7037": "31734310666297",
  "C3604-9005": "31734310469689",
  "C3604-9006": "31734310699065",
  "C3604-9010": "31734310731833",
  "C3604-9016": "31734310764601",
  "C3604-TB": "31734310436921",
  "C3604-TBA": "31734310797369",
  "C3605-7016": "31734328524857",
  "C3605-7021": "31734328557625",
  "C3605-7022": "31734328590393",
  "C3605-7035": "31734328623161",
  "C3605-7036": "31734328655929",
  "C3605-7037": "31734328688697",
  "C3605-9005": "31734328492089",
  "C3605-9006": "31734328721465",
  "C3605-9010": "31734328754233",
  "C3605-9016": "31734328787001",
  "C3605-TB": "31734328459321",
  "C3605-TBA": "31734328819769",
  "C420-7016": "31731132334137",
  "C420-7021": "31731132366905",
  "C420-7022": "31731132399673",
  "C420-7035": "31731132432441",
  "C420-7036": "31731132465209",
  "C420-7037": "31731132497977",
  "C420-9005": "31731132301369",
  "C420-9006": "31731132530745",
  "C420-9010": "31731132563513",
  "C420-9016": "31731132596281",
  "C420-TB": "31731132268601",
  "C420-TBA": "31731132629049",
  "C4201-7016": "31734237560889",
  "C4201-7021": "31734237593657",
  "C4201-7022": "31734237626425",
  "C4201-7035": "31734237659193",
  "C4201-7036": "31734237691961",
  "C4201-7037": "31734237724729",
  "C4201-9005": "31734237528121",
  "C4201-9006": "31734237757497",
  "C4201-9010": "31734237790265",
  "C4201-9016": "31734237823033",
  "C4201-TB": "31734237495353",
  "C4201-TBA": "31734237855801",
  "C4202-7016": "31734299295801",
  "C4202-7021": "31734299328569",
  "C4202-7022": "31734299361337",
  "C4202-7035": "31734299394105",
  "C4202-7036": "31734299426873",
  "C4202-7037": "31734299459641",
  "C4202-9005": "31734299263033",
  "C4202-9006": "31734299492409",
  "C4202-9010": "31734299525177",
  "C4202-9016": "31734299557945",
  "C4202-TB": "31734299230265",
  "C4202-TBA": "31734299590713",
  "C4203-7016": "31734304473145",
  "C4203-7021": "31734304505913",
  "C4203-7022": "31734304538681",
  "C4203-7035": "31734304571449",
  "C4203-7036": "31734304604217",
  "C4203-7037": "31734304636985",
  "C4203-9005": "31734304440377",
  "C4203-9006": "31734304669753",
  "C4203-9010": "31734304702521",
  "C4203-9016": "31734304735289",
  "C4203-TB": "31734304407609",
  "C4203-TBA": "31734304768057",
  "C4204-7016": "31734310895673",
  "C4204-7021": "31734310928441",
  "C4204-7022": "31734310961209",
  "C4204-7035": "31734310993977",
  "C4204-7036": "31734311026745",
  "C4204-7037": "31734311059513",
  "C4204-9005": "31734310862905",
  "C4204-9006": "31734311092281",
  "C4204-9010": "31734311125049",
  "C4204-9016": "31734311157817",
  "C4204-TB": "31734310830137",
  "C4204-TBA": "31734311190585",
  "C4205-7016": "31734328918073",
  "C4205-7021": "31734328950841",
  "C4205-7022": "31734328983609",
  "C4205-7035": "31734329016377",
  "C4205-7036": "31734329049145",
  "C4205-7037": "31734329081913",
  "C4205-9005": "31734328885305",
  "C4205-9006": "31734329114681",
  "C4205-9010": "31734329147449",
  "C4205-9016": "31734329180217",
  "C4205-TB": "31734328852537",
  "C4205-TBA": "31734329212985",
  "DF631-7016": "31708801040441",
  "DF631-7021": "31708801073209",
  "DF631-7022": "31708801138745",
  "DF631-7035": "31708801171513",
  "DF631-7036": "31708801204281",
  "DF631-7037": "31708801237049",
  "DF631-9005": "31708800974905",
  "DF631-9006": "31708801269817",
  "DF631-9010": "31708801302585",
  "DF631-9016": "31708801335353",
  "DF631-TB": "31708800909369",
  "DF631-TBA": "31708801368121",
  "DF6310-7016": "31718307954745",
  "DF6310-7021": "31718307987513",
  "DF6310-7022": "31718308020281",
  "DF6310-7035": "31718308053049",
  "DF6310-7036": "31718308085817",
  "DF6310-7037": "31718308118585",
  "DF6310-9005": "31718307921977",
  "DF6310-9006": "31718308151353",
  "DF6310-9010": "31718308184121",
  "DF6310-9016": "31718308216889",
  "DF6310-TB": "31718307889209",
  "DF6310-TBA": "31718308249657",
  "DF6311-7016": "31718354157625",
  "DF6311-7021": "31718354190393",
  "DF6311-7022": "31718354223161",
  "DF6311-7035": "31718354255929",
  "DF6311-7036": "31718354288697",
  "DF6311-7037": "31718354321465",
  "DF6311-9005": "31718354124857",
  "DF6311-9006": "31718354354233",
  "DF6311-9010": "31718354387001",
  "DF6311-9016": "31718354419769",
  "DF6311-TB": "31718354092089",
  "DF6311-TBA": "31718354452537",
  "DF6312-7016": "31718368772153",
  "DF6312-7021": "31718368804921",
  "DF6312-7022": "31718368837689",
  "DF6312-7035": "31718368870457",
  "DF6312-7036": "31718368903225",
  "DF6312-7037": "31718368935993",
  "DF6312-9005": "31718368739385",
  "DF6312-9006": "31718368968761",
  "DF6312-9010": "31718369001529",
  "DF6312-9016": "31718369034297",
  "DF6312-TB": "31718368706617",
  "DF6312-TBA": "31718369067065",
  "DF6313-7016": "31718027329593",
  "DF6313-7021": "31718027362361",
  "DF6313-7022": "31718027395129",
  "DF6313-7035": "31718027427897",
  "DF6313-7036": "31718027460665",
  "DF6313-7037": "31718027493433",
  "DF6313-9005": "31718027296825",
  "DF6313-9006": "31718027526201",
  "DF6313-9010": "31718027558969",
  "DF6313-9016": "31718027591737",
  "DF6313-TB": "31718027264057",
  "DF6313-TBA": "31718027624505",
  "DF632-7016": "31717907365945",
  "DF632-7021": "31717907398713",
  "DF632-7022": "31717907431481",
  "DF632-7035": "31717907464249",
  "DF632-7036": "31717907497017",
  "DF632-7037": "31717907529785",
  "DF632-9005": "31717907333177",
  "DF632-9006": "31717907562553",
  "DF632-9010": "31717907595321",
  "DF632-9016": "31717907628089",
  "DF632-TB": "31717907267641",
  "DF632-TBA": "31717907660857",
  "DF633-7016": "31717946753081",
  "DF633-7021": "31717946785849",
  "DF633-7022": "31717946818617",
  "DF633-7035": "31717946851385",
  "DF633-7036": "31717946884153",
  "DF633-7037": "31717946916921",
  "DF633-9005": "31717946720313",
  "DF633-9006": "31717946949689",
  "DF633-9010": "31717946982457",
  "DF633-9016": "31717947015225",
  "DF633-TB": "31717946687545",
  "DF633-TBA": "31717947047993",
  "DF634-7016": "31717955403833",
  "DF634-7021": "31717955436601",
  "DF634-7022": "31717955469369",
  "DF634-7035": "31717955502137",
  "DF634-7036": "31717955534905",
  "DF634-7037": "31717955567673",
  "DF634-9005": "31717955371065",
  "DF634-9006": "31717955600441",
  "DF634-9010": "31717955633209",
  "DF634-9016": "31717955665977",
  "DF634-TB": "31717955338297",
  "DF634-TBA": "31717955698745",
  "DF6351-7016": "39761334304825",
  "DF6351-7021": "39761334370361",
  "DF6351-7022": "39761334435897",
  "DF6351-7035": "39761334501433",
  "DF6351-7036": "39761334566969",
  "DF6351-7037": "39761334632505",
  "DF6351-9005": "39761334239289",
  "DF6351-9006": "39761334698041",
  "DF6351-9010": "39761334763577",
  "DF6351-9016": "39761334829113",
  "DF6351-TB": "39761334173753",
  "DF6351-TBA": "39761334894649",
  "DF6352-7016": "31718002786361",
  "DF6352-7021": "31718002819129",
  "DF6352-7022": "31718002851897",
  "DF6352-7035": "31718002884665",
  "DF6352-7036": "31718002917433",
  "DF6352-7037": "31718002950201",
  "DF6352-9005": "31718002753593",
  "DF6352-9006": "31718002982969",
  "DF6352-9010": "31718003015737",
  "DF6352-9016": "31718003048505",
  "DF6352-TB": "31718002720825",
  "DF6352-TBA": "31718003081273",
  "DF6355-7016": "39761334272057",
  "DF6355-7021": "39761334337593",
  "DF6355-7022": "39761334403129",
  "DF6355-7035": "39761334468665",
  "DF6355-7036": "39761334534201",
  "DF6355-7037": "39761334599737",
  "DF6355-9005": "39761334206521",
  "DF6355-9006": "39761334665273",
  "DF6355-9010": "39761334730809",
  "DF6355-9016": "39761334796345",
  "DF6355-TB": "39761334140985",
  "DF6355-TBA": "39761334861881",
  "DF636-7016": "31718109577273",
  "DF636-7021": "31718109610041",
  "DF636-7022": "31718109642809",
  "DF636-7035": "31718109675577",
  "DF636-7036": "31718109708345",
  "DF636-7037": "31718109741113",
  "DF636-9005": "31718109544505",
  "DF636-9006": "31718109773881",
  "DF636-9010": "31718109806649",
  "DF636-9016": "31718109839417",
  "DF636-TB": "31718109511737",
  "DF636-TBA": "31718109872185",
  "DF637-7016": "39761237213241",
  "DF637-7021": "39761237246009",
  "DF637-7022": "39761237278777",
  "DF637-7035": "39761237311545",
  "DF637-7036": "39761237344313",
  "DF637-7037": "39761237377081",
  "DF637-9005": "39761237180473",
  "DF637-9006": "39761237409849",
  "DF637-9010": "39761237442617",
  "DF637-9016": "39761237475385",
  "DF637-TB": "39761237147705",
  "DF637-TBA": "39761237508153",
  "DF638-7016": "31718215843897",
  "DF638-7021": "31718215876665",
  "DF638-7022": "31718215909433",
  "DF638-7035": "31718215942201",
  "DF638-7036": "31718215974969",
  "DF638-7037": "31718216007737",
  "DF638-9005": "31718215811129",
  "DF638-9006": "31718216040505",
  "DF638-9010": "31718216073273",
  "DF638-9016": "31718216106041",
  "DF638-TB": "31718215778361",
  "DF638-TBA": "31718216138809",
  "DF639-7016": "39761358422073",
  "DF639-7021": "39761358454841",
  "DF639-7022": "39761358487609",
  "DF639-7035": "39761358520377",
  "DF639-7036": "39761358553145",
  "DF639-7037": "39761358585913",
  "DF639-9005": "39761358389305",
  "DF639-9006": "39761358618681",
  "DF639-9010": "39761358651449",
  "DF639-9016": "39761358684217",
  "DF639-TB": "39761358356537",
  "DF639-TBA": "39761358716985",
  "DF721-7016": "31718533726265",
  "DF721-7021": "31718533759033",
  "DF721-7022": "31718533791801",
  "DF721-7035": "31718533824569",
  "DF721-7036": "31718533857337",
  "DF721-7037": "31718533890105",
  "DF721-9005": "31718533693497",
  "DF721-9006": "31718533922873",
  "DF721-9010": "31718533955641",
  "DF721-9016": "31718533988409",
  "DF721-TB": "31718533660729",
  "DF721-TBA": "31718534021177",
  "DF7210-7016": "31718596083769",
  "DF7210-7021": "31718596116537",
  "DF7210-7022": "31718596149305",
  "DF7210-7035": "31718596182073",
  "DF7210-7036": "31718596214841",
  "DF7210-7037": "31718596247609",
  "DF7210-9005": "31718596051001",
  "DF7210-9006": "31718596280377",
  "DF7210-9010": "31718596313145",
  "DF7210-9016": "31718596345913",
  "DF7210-TB": "31718596018233",
  "DF7210-TBA": "31718596378681",
  "DF7211-7016": "31718599426105",
  "DF7211-7021": "31718599458873",
  "DF7211-7022": "31718599491641",
  "DF7211-7035": "31718599524409",
  "DF7211-7036": "31718599557177",
  "DF7211-7037": "31718599589945",
  "DF7211-9005": "31718599393337",
  "DF7211-9006": "31718599622713",
  "DF7211-9010": "31718599655481",
  "DF7211-9016": "31718599688249",
  "DF7211-TB": "31718599360569",
  "DF7211-TBA": "31718599721017",
  "DF7212-7016": "31718601916473",
  "DF7212-7021": "31718601949241",
  "DF7212-7022": "31718601982009",
  "DF7212-7035": "31718602014777",
  "DF7212-7036": "31718602047545",
  "DF7212-7037": "31718602080313",
  "DF7212-9005": "31718601883705",
  "DF7212-9006": "31718602113081",
  "DF7212-9010": "31718602145849",
  "DF7212-9016": "31718602178617",
  "DF7212-TB": "31718601850937",
  "DF7212-TBA": "31718602211385",
  "DF7213-7016": "31718575439929",
  "DF7213-7021": "31718575472697",
  "DF7213-7022": "31718575505465",
  "DF7213-7035": "31718575538233",
  "DF7213-7036": "31718575571001",
  "DF7213-7037": "31718575603769",
  "DF7213-9005": "31718575407161",
  "DF7213-9006": "31718575636537",
  "DF7213-9010": "31718575702073",
  "DF7213-9016": "31718575734841",
  "DF7213-TB": "31718575374393",
  "DF7213-TBA": "31718575767609",
  "DF722-7016": "31718546964537",
  "DF722-7021": "31718547030073",
  "DF722-7022": "31724424855609",
  "DF722-7035": "31718547062841",
  "DF722-7036": "31718547095609",
  "DF722-7037": "31718547128377",
  "DF722-9005": "31718546931769",
  "DF722-9006": "31718547161145",
  "DF722-9010": "31718547193913",
  "DF722-9016": "31718547226681",
  "DF722-TB": "31718546899001",
  "DF722-TBA": "31718547259449",
  "DF723-7016": "31718551060537",
  "DF723-7021": "31718551126073",
  "DF723-7022": "31718551158841",
  "DF723-7035": "31718551191609",
  "DF723-7036": "31718551224377",
  "DF723-7037": "31718551257145",
  "DF723-9005": "31718550995001",
  "DF723-9006": "31718551289913",
  "DF723-9010": "31718551322681",
  "DF723-9016": "31718551355449",
  "DF723-TB": "31718550929465",
  "DF723-TBA": "31718551388217",
  "DF724-7016": "31718557122617",
  "DF724-7021": "31718557155385",
  "DF724-7022": "31718557188153",
  "DF724-7035": "31718557220921",
  "DF724-7036": "31718557253689",
  "DF724-7037": "31718557286457",
  "DF724-9005": "31718557089849",
  "DF724-9006": "31718557319225",
  "DF724-9010": "31718557351993",
  "DF724-9016": "31718557384761",
  "DF724-TB": "31718557057081",
  "DF724-TBA": "31718557417529",
  "DF7251-7016": "39761883496505",
  "DF7251-7021": "39761883562041",
  "DF7251-7022": "39761883627577",
  "DF7251-7035": "39761883693113",
  "DF7251-7036": "39761883758649",
  "DF7251-7037": "39761883824185",
  "DF7251-9005": "39761883430969",
  "DF7251-9006": "39761883889721",
  "DF7251-9010": "39761883955257",
  "DF7251-9016": "39761884020793",
  "DF7251-TB": "39761883365433",
  "DF7251-TBA": "39761884086329",
  "DF7252-7016": "31718561480761",
  "DF7252-7021": "31718561513529",
  "DF7252-7022": "31718561546297",
  "DF7252-7035": "31718561579065",
  "DF7252-7036": "31718561611833",
  "DF7252-7037": "31718561644601",
  "DF7252-9005": "31718561447993",
  "DF7252-9006": "31718561677369",
  "DF7252-9010": "31718561710137",
  "DF7252-9016": "31718561742905",
  "DF7252-TB": "31718561415225",
  "DF7252-TBA": "31718561775673",
  "DF7255-7016": "39761883463737",
  "DF7255-7021": "39761883529273",
  "DF7255-7022": "39761883594809",
  "DF7255-7035": "39761883660345",
  "DF7255-7036": "39761883725881",
  "DF7255-7037": "39761883791417",
  "DF7255-9005": "39761883398201",
  "DF7255-9006": "39761883856953",
  "DF7255-9010": "39761883922489",
  "DF7255-9016": "39761883988025",
  "DF7255-TB": "39761883332665",
  "DF7255-TBA": "39761884053561",
  "DF726-7016": "31718579077177",
  "DF726-7021": "31718579109945",
  "DF726-7022": "31718579142713",
  "DF726-7035": "31718579175481",
  "DF726-7036": "31718579208249",
  "DF726-7037": "31718579241017",
  "DF726-9005": "31718579044409",
  "DF726-9006": "31718579273785",
  "DF726-9010": "31718579306553",
  "DF726-9016": "31718579339321",
  "DF726-TB": "31718579011641",
  "DF726-TBA": "31718579372089",
  "DF727-7016": "39761949261881",
  "DF727-7021": "39761949294649",
  "DF727-7022": "39761949327417",
  "DF727-7035": "39761949360185",
  "DF727-7036": "39761949392953",
  "DF727-7037": "39761949425721",
  "DF727-9005": "39761949229113",
  "DF727-9006": "39761949458489",
  "DF727-9010": "39761949491257",
  "DF727-9016": "39761949524025",
  "DF727-TB": "39761949196345",
  "DF727-TBA": "39761949556793",
  "DF728-7016": "31718585663545",
  "DF728-7021": "31718585696313",
  "DF728-7022": "31718585729081",
  "DF728-7035": "31718585761849",
  "DF728-7036": "31718585794617",
  "DF728-7037": "31718585827385",
  "DF728-9005": "31718585630777",
  "DF728-9006": "31718585860153",
  "DF728-9010": "31718585892921",
  "DF728-9016": "31718585925689",
  "DF728-TB": "31718585598009",
  "DF728-TBA": "31718585958457",
  "DF729-7016": "39763461865529",
  "DF729-7021": "39763461898297",
  "DF729-7022": "39763461931065",
  "DF729-7035": "39763461963833",
  "DF729-7036": "39763461996601",
  "DF729-7037": "39763462029369",
  "DF729-9005": "39763461832761",
  "DF729-9006": "39763462062137",
  "DF729-9010": "39763462094905",
  "DF729-9016": "39763462127673",
  "DF729-TB": "39763461799993",
  "DF729-TBA": "39763462160441",
  "DF761-7016": "31709365141561",
  "DF761-7021": "31709365174329",
  "DF761-7022": "31709365207097",
  "DF761-7035": "31709365239865",
  "DF761-7036": "31709365272633",
  "DF761-7037": "31709365305401",
  "DF761-9005": "31709365108793",
  "DF761-9006": "31709365338169",
  "DF761-9010": "31709365370937",
  "DF761-9016": "31709365403705",
  "DF761-TB": "31709365076025",
  "DF761-TBA": "31709365436473",
  "DF7610-7016": "31718336069689",
  "DF7610-7021": "31718336102457",
  "DF7610-7022": "31718336135225",
  "DF7610-7035": "31718336167993",
  "DF7610-7036": "31718336200761",
  "DF7610-7037": "31718336233529",
  "DF7610-9005": "31718336036921",
  "DF7610-9006": "31718336266297",
  "DF7610-9010": "31718336299065",
  "DF7610-9016": "31718336331833",
  "DF7610-TB": "31718336004153",
  "DF7610-TBA": "31718336364601",
  "DF7611-7016": "31718349537337",
  "DF7611-7021": "31718349570105",
  "DF7611-7022": "31718349635641",
  "DF7611-7035": "31718349668409",
  "DF7611-7036": "31718349701177",
  "DF7611-7037": "31718349766713",
  "DF7611-9005": "31718349504569",
  "DF7611-9006": "31718349799481",
  "DF7611-9010": "31718349832249",
  "DF7611-9016": "31718349897785",
  "DF7611-TB": "31718349439033",
  "DF7611-TBA": "31718349930553",
  "DF7612-7016": "31718385680441",
  "DF7612-7021": "31718385713209",
  "DF7612-7022": "31718385745977",
  "DF7612-7035": "31718385778745",
  "DF7612-7036": "31718385811513",
  "DF7612-7037": "31718385877049",
  "DF7612-9005": "31718385647673",
  "DF7612-9006": "31718385942585",
  "DF7612-9010": "31718386008121",
  "DF7612-9016": "31718386073657",
  "DF7612-TB": "31718385614905",
  "DF7612-TBA": "31718386139193",
  "DF7613-7016": "31718080938041",
  "DF7613-7021": "31718080970809",
  "DF7613-7022": "31718081003577",
  "DF7613-7035": "31718081036345",
  "DF7613-7036": "31718081069113",
  "DF7613-7037": "31718081101881",
  "DF7613-9005": "31718080905273",
  "DF7613-9006": "31718081134649",
  "DF7613-9010": "31718081167417",
  "DF7613-9016": "31718081200185",
  "DF7613-TB": "31718080872505",
  "DF7613-TBA": "31718081232953",
  "DF762-7016": "31717935448121",
  "DF762-7021": "31717935480889",
  "DF762-7022": "31717935513657",
  "DF762-7035": "31717935546425",
  "DF762-7036": "31717935579193",
  "DF762-7037": "31717935611961",
  "DF762-9005": "31717935415353",
  "DF762-9006": "31717935644729",
  "DF762-9010": "31717935677497",
  "DF762-9016": "31717935710265",
  "DF762-TB": "31717935382585",
  "DF762-TBA": "31717935743033",
  "DF763-7016": "31717940101177",
  "DF763-7021": "31717940133945",
  "DF763-7022": "31717940166713",
  "DF763-7035": "31717940199481",
  "DF763-7036": "31717940232249",
  "DF763-7037": "31717940265017",
  "DF763-9005": "31717940068409",
  "DF763-9006": "31717940297785",
  "DF763-9010": "31717940330553",
  "DF763-9016": "31717940363321",
  "DF763-TB": "31717940035641",
  "DF763-TBA": "31717940396089",
  "DF764-7016": "31717978439737",
  "DF764-7021": "31717978472505",
  "DF764-7022": "31717978505273",
  "DF764-7035": "31717978538041",
  "DF764-7036": "31717978570809",
  "DF764-7037": "31717978603577",
  "DF764-9005": "31717978406969",
  "DF764-9006": "31717978636345",
  "DF764-9010": "31717978669113",
  "DF764-9016": "31717978701881",
  "DF764-TB": "31717978374201",
  "DF764-TBA": "31717978734649",
  "DF7651-7016": "39761384865849",
  "DF7651-7021": "39761384931385",
  "DF7651-7022": "39761384996921",
  "DF7651-7035": "39761385062457",
  "DF7651-7036": "39761385127993",
  "DF7651-7037": "39761385193529",
  "DF7651-9005": "39761384800313",
  "DF7651-9006": "39761385259065",
  "DF7651-9010": "39761385324601",
  "DF7651-9016": "39761385390137",
  "DF7651-TB": "39761384734777",
  "DF7651-TBA": "39761385455673",
  "DF7652-7016": "31718045057081",
  "DF7652-7021": "31718045089849",
  "DF7652-7022": "31718045122617",
  "DF7652-7035": "31718045155385",
  "DF7652-7036": "31718045188153",
  "DF7652-7037": "31718045220921",
  "DF7652-9005": "31718045024313",
  "DF7652-9006": "31718045253689",
  "DF7652-9010": "31718045286457",
  "DF7652-9016": "31718045319225",
  "DF7652-TB": "31718044991545",
  "DF7652-TBA": "31718045351993",
  "DF7655-7016": "39761384833081",
  "DF7655-7021": "39761384898617",
  "DF7655-7022": "39761384964153",
  "DF7655-7035": "39761385029689",
  "DF7655-7036": "39761385095225",
  "DF7655-7037": "39761385160761",
  "DF7655-9005": "39761384767545",
  "DF7655-9006": "39761385226297",
  "DF7655-9010": "39761385291833",
  "DF7655-9016": "39761385357369",
  "DF7655-TB": "39761384702009",
  "DF7655-TBA": "39761385422905",
  "DF766-7016": "31718197821497",
  "DF766-7021": "31718197854265",
  "DF766-7022": "31718197887033",
  "DF766-7035": "31718197919801",
  "DF766-7036": "31718197952569",
  "DF766-7037": "31718197985337",
  "DF766-9005": "31718197788729",
  "DF766-9006": "31718198018105",
  "DF766-9010": "31718198050873",
  "DF766-9016": "31718198083641",
  "DF766-TB": "31718197755961",
  "DF766-TBA": "31718198116409",
  "DF767-7016": "39761369071673",
  "DF767-7021": "39761369104441",
  "DF767-7022": "39761369137209",
  "DF767-7035": "39761369169977",
  "DF767-7036": "39761369202745",
  "DF767-7037": "39761369235513",
  "DF767-9005": "39761369038905",
  "DF767-9006": "39761369268281",
  "DF767-9010": "39761369301049",
  "DF767-9016": "39761369333817",
  "DF767-TB": "39761369006137",
  "DF767-TBA": "39761369366585",
  "DF768-7016": "31718260932665",
  "DF768-7021": "31718260965433",
  "DF768-7022": "31718260998201",
  "DF768-7035": "31718261030969",
  "DF768-7036": "31718261063737",
  "DF768-7037": "31718261096505",
  "DF768-9005": "31718260899897",
  "DF768-9006": "31718261129273",
  "DF768-9010": "31718261162041",
  "DF768-9016": "31718261194809",
  "DF768-TB": "31718260867129",
  "DF768-TBA": "31718261227577",
  "DF769-7016": "39761402888249",
  "DF769-7021": "39761402921017",
  "DF769-7022": "39761402953785",
  "DF769-7035": "39761402986553",
  "DF769-7036": "39761403019321",
  "DF769-7037": "39761403052089",
  "DF769-9005": "39761402855481",
  "DF769-9006": "39761403084857",
  "DF769-9010": "39761403117625",
  "DF769-9016": "39761403183161",
  "DF769-TB": "39761402822713",
  "DF769-TBA": "39761403215929",
  "DT631-7016": "31718689800249",
  "DT631-7021": "31718689833017",
  "DT631-7022": "31718689865785",
  "DT631-7035": "31718689898553",
  "DT631-7036": "31718689931321",
  "DT631-7037": "31718689964089",
  "DT631-9005": "31718689767481",
  "DT631-9006": "31718689996857",
  "DT631-9010": "31718690029625",
  "DT631-9016": "31718690062393",
  "DT631-TB": "31718689734713",
  "DT631-TBA": "31718690095161",
  "DT6311-7016": "31719243481145",
  "DT6311-7021": "31719243513913",
  "DT6311-7022": "31719243546681",
  "DT6311-7035": "31719243579449",
  "DT6311-7036": "31719243612217",
  "DT6311-7037": "31719243644985",
  "DT6311-9005": "31719243448377",
  "DT6311-9006": "31719243677753",
  "DT6311-9010": "31719243710521",
  "DT6311-9016": "31719243743289",
  "DT6311-TB": "31719243415609",
  "DT6311-TBA": "31719243776057",
  "DT6312-7016": "31719251738681",
  "DT6312-7021": "31719251771449",
  "DT6312-7022": "31719251804217",
  "DT6312-7035": "31719251836985",
  "DT6312-7036": "31719251869753",
  "DT6312-7037": "31719251902521",
  "DT6312-9005": "31719251705913",
  "DT6312-9006": "31719251935289",
  "DT6312-9010": "31719251968057",
  "DT6312-9016": "31719252000825",
  "DT6312-TB": "31719251673145",
  "DT6312-TBA": "31719252033593",
  "DT631NE-7016": "31719283785785",
  "DT631NE-7021": "31719283818553",
  "DT631NE-7022": "31719283851321",
  "DT631NE-7035": "31719283884089",
  "DT631NE-7036": "31719283916857",
  "DT631NE-7037": "31719283949625",
  "DT631NE-9005": "31719283753017",
  "DT631NE-9006": "31719283982393",
  "DT631NE-9010": "31719284015161",
  "DT631NE-9016": "31719284047929",
  "DT631NE-TB": "31719283720249",
  "DT631NE-TBA": "31719284080697",
  "DT634-7016": "31718998966329",
  "DT634-7021": "31718998999097",
  "DT634-7022": "31718999031865",
  "DT634-7035": "31718999064633",
  "DT634-7036": "31718999097401",
  "DT634-7037": "31718999130169",
  "DT634-9005": "31718998933561",
  "DT634-9006": "31718999162937",
  "DT634-9010": "31718999195705",
  "DT634-9016": "31718999228473",
  "DT634-TB": "31718998900793",
  "DT634-TBA": "31718999261241",
  "DT634NE-7016": "31719158022201",
  "DT634NE-7021": "31719158054969",
  "DT634NE-7022": "31719158087737",
  "DT634NE-7035": "31719158120505",
  "DT634NE-7036": "31719158153273",
  "DT634NE-7037": "31719158186041",
  "DT634NE-9005": "31719157989433",
  "DT634NE-9006": "31719158218809",
  "DT634NE-9010": "31719158251577",
  "DT634NE-9016": "31719158284345",
  "DT634NE-TB": "31719157956665",
  "DT634NE-TBA": "31719158317113",
  "DT6351-7016": "39761520525369",
  "DT6351-7021": "39761520590905",
  "DT6351-7022": "39761520656441",
  "DT6351-7035": "39761520721977",
  "DT6351-7036": "39761520787513",
  "DT6351-7037": "39761520853049",
  "DT6351-9005": "39761520459833",
  "DT6351-9006": "39761520918585",
  "DT6351-9010": "39761520984121",
  "DT6351-9016": "39761521049657",
  "DT6351-TB": "39761520394297",
  "DT6351-TBA": "39761521115193",
  "DT6352-7016": "31719163166777",
  "DT6352-7021": "31719163199545",
  "DT6352-7022": "31719163232313",
  "DT6352-7035": "31719163265081",
  "DT6352-7036": "31719163297849",
  "DT6352-7037": "31719163330617",
  "DT6352-9005": "31719163134009",
  "DT6352-9006": "31719163363385",
  "DT6352-9010": "31719163396153",
  "DT6352-9016": "31719163428921",
  "DT6352-TB": "31719163101241",
  "DT6352-TBA": "31719163461689",
  "DT6355-7016": "39761520492601",
  "DT6355-7021": "39761520558137",
  "DT6355-7022": "39761520623673",
  "DT6355-7035": "39761520689209",
  "DT6355-7036": "39761520754745",
  "DT6355-7037": "39761520820281",
  "DT6355-9005": "39761520427065",
  "DT6355-9006": "39761520885817",
  "DT6355-9010": "39761520951353",
  "DT6355-9016": "39761521016889",
  "DT6355-TB": "39761520361529",
  "DT6355-TBA": "39761521082425",
  "DT636-7016": "31719205634105",
  "DT636-7021": "31719205666873",
  "DT636-7022": "31719205699641",
  "DT636-7035": "31719205732409",
  "DT636-7036": "31719205765177",
  "DT636-7037": "31719205797945",
  "DT636-9005": "31719205601337",
  "DT636-9006": "31719205830713",
  "DT636-9010": "31719205863481",
  "DT636-9016": "31719205896249",
  "DT636-TB": "31719205568569",
  "DT636-TBA": "31719205929017",
  "DT637-7016": "39761585963065",
  "DT637-7021": "39761586028601",
  "DT637-7022": "39761586061369",
  "DT637-7035": "39761586094137",
  "DT637-7036": "39761586126905",
  "DT637-7037": "39761586159673",
  "DT637-9005": "39761585930297",
  "DT637-9006": "39761586192441",
  "DT637-9010": "39761586225209",
  "DT637-9016": "39761586257977",
  "DT637-TB": "39761585897529",
  "DT637-TBA": "39761586290745",
  "DT638-7016": "31719228637241",
  "DT638-7021": "31719228670009",
  "DT638-7022": "31719228702777",
  "DT638-7035": "31719228735545",
  "DT638-7036": "31719228768313",
  "DT638-7037": "31719228801081",
  "DT638-9005": "31719228604473",
  "DT638-9006": "31719228833849",
  "DT638-9010": "31719228866617",
  "DT638-9016": "31719228899385",
  "DT638-TB": "31719228571705",
  "DT638-TBA": "31719228932153",
  "DT639-7016": "39761692196921",
  "DT639-7021": "39761692229689",
  "DT639-7022": "39761692262457",
  "DT639-7035": "39761692295225",
  "DT639-7036": "39761692327993",
  "DT639-7037": "39761692360761",
  "DT639-9005": "39761692164153",
  "DT639-9006": "39761692393529",
  "DT639-9010": "39761692426297",
  "DT639-9016": "39761692459065",
  "DT639-TB": "39761692131385",
  "DT639-TBA": "39761692491833",
  "DT721-7016": "31724420366393",
  "DT721-7021": "31724420399161",
  "DT721-7022": "31724420431929",
  "DT721-7035": "31724420464697",
  "DT721-7036": "31724420497465",
  "DT721-7037": "31724420530233",
  "DT721-9005": "31724420333625",
  "DT721-9006": "31724420563001",
  "DT721-9010": "31724420595769",
  "DT721-9016": "31724420628537",
  "DT721-TB": "31724420300857",
  "DT721-TBA": "31724420661305",
  "DT7211-7016": "31724515328057",
  "DT7211-7021": "31724515360825",
  "DT7211-7022": "31724515393593",
  "DT7211-7035": "31724515426361",
  "DT7211-7036": "31724515459129",
  "DT7211-7037": "31724515491897",
  "DT7211-9005": "31724515295289",
  "DT7211-9006": "31724515524665",
  "DT7211-9010": "31724515557433",
  "DT7211-9016": "31724515590201",
  "DT7211-TB": "31724515262521",
  "DT7211-TBA": "31724515622969",
  "DT7212-7016": "31724520243257",
  "DT7212-7021": "31724520276025",
  "DT7212-7022": "31724520308793",
  "DT7212-7035": "31724520341561",
  "DT7212-7036": "31724520374329",
  "DT7212-7037": "31724520407097",
  "DT7212-9005": "31724520210489",
  "DT7212-9006": "31724520439865",
  "DT7212-9010": "31724520472633",
  "DT7212-9016": "31724520505401",
  "DT7212-TB": "31724520177721",
  "DT7212-TBA": "31724520538169",
  "DT721NE-7016": "31724413616185",
  "DT721NE-7021": "31724413648953",
  "DT721NE-7022": "31724413681721",
  "DT721NE-7035": "31724413714489",
  "DT721NE-7036": "31724413747257",
  "DT721NE-7037": "31724413780025",
  "DT721NE-9005": "31724413583417",
  "DT721NE-9006": "31724413812793",
  "DT721NE-9010": "31724413845561",
  "DT721NE-9016": "31724413878329",
  "DT721NE-TB": "31724413550649",
  "DT721NE-TBA": "31724413911097",
  "DT724-7016": "31724439109689",
  "DT724-7021": "31724439142457",
  "DT724-7022": "31724439175225",
  "DT724-7035": "31724439207993",
  "DT724-7036": "31724439240761",
  "DT724-7037": "31724439273529",
  "DT724-9005": "31724439076921",
  "DT724-9006": "31724439306297",
  "DT724-9010": "31724439339065",
  "DT724-9016": "31724439371833",
  "DT724-TB": "31724439044153",
  "DT724-TBA": "31724439404601",
  "DT724NE-7016": "31724448415801",
  "DT724NE-7021": "31724448448569",
  "DT724NE-7022": "31724448481337",
  "DT724NE-7035": "31724448514105",
  "DT724NE-7036": "31724448546873",
  "DT724NE-7037": "31724448579641",
  "DT724NE-9005": "31724448383033",
  "DT724NE-9006": "31724448612409",
  "DT724NE-9010": "31724448645177",
  "DT724NE-9016": "31724448677945",
  "DT724NE-TB": "31724448350265",
  "DT724NE-TBA": "31724448710713",
  "DT7251-7016": "39763535233081",
  "DT7251-7021": "39763535298617",
  "DT7251-7022": "39763535364153",
  "DT7251-7035": "39763535429689",
  "DT7251-7036": "39763535495225",
  "DT7251-7037": "39763535560761",
  "DT7251-9005": "39763535167545",
  "DT7251-9006": "39763535626297",
  "DT7251-9010": "39763535691833",
  "DT7251-9016": "39763535757369",
  "DT7251-TB": "39763535102009",
  "DT7251-TBA": "39763535822905",
  "DT7252-7016": "31724449955897",
  "DT7252-7021": "31724449988665",
  "DT7252-7022": "31724450021433",
  "DT7252-7035": "31724450054201",
  "DT7252-7036": "31724450086969",
  "DT7252-7037": "31724450119737",
  "DT7252-9005": "31724449923129",
  "DT7252-9006": "31724450152505",
  "DT7252-9010": "31724450185273",
  "DT7252-9016": "31724450218041",
  "DT7252-TB": "31724449890361",
  "DT7252-TBA": "31724450250809",
  "DT7255-7016": "39763535200313",
  "DT7255-7021": "39763535265849",
  "DT7255-7022": "39763535331385",
  "DT7255-7035": "39763535396921",
  "DT7255-7036": "39763535462457",
  "DT7255-7037": "39763535527993",
  "DT7255-9005": "39763535134777",
  "DT7255-9006": "39763535593529",
  "DT7255-9010": "39763535659065",
  "DT7255-9016": "39763535724601",
  "DT7255-TB": "39763535069241",
  "DT7255-TBA": "39763535790137",
  "DT726-7016": "31724467159097",
  "DT726-7021": "31724467191865",
  "DT726-7022": "31724467224633",
  "DT726-7035": "31724467257401",
  "DT726-7036": "31724467290169",
  "DT726-7037": "31724467322937",
  "DT726-9005": "31724467126329",
  "DT726-9006": "31724467355705",
  "DT726-9010": "31724467388473",
  "DT726-9016": "31724467421241",
  "DT726-TB": "31724467093561",
  "DT726-TBA": "31724467454009",
  "DT727-7016": "39763547717689",
  "DT727-7021": "39763547750457",
  "DT727-7022": "39763547783225",
  "DT727-7035": "39763547815993",
  "DT727-7036": "39763547848761",
  "DT727-7037": "39763547881529",
  "DT727-9005": "39763547684921",
  "DT727-9006": "39763547914297",
  "DT727-9010": "39763547947065",
  "DT727-9016": "39763547979833",
  "DT727-TB": "39763547652153",
  "DT727-TBA": "39763548012601",
  "DT728-7016": "31724475678777",
  "DT728-7021": "31724475711545",
  "DT728-7022": "31724475744313",
  "DT728-7035": "31724475777081",
  "DT728-7036": "31724475809849",
  "DT728-7037": "31724475842617",
  "DT728-9005": "31724475646009",
  "DT728-9006": "31724475875385",
  "DT728-9010": "31724475908153",
  "DT728-9016": "31724475940921",
  "DT728-TB": "31724475613241",
  "DT728-TBA": "31724475973689",
  "DT729-7016": "39763595493433",
  "DT729-7021": "39763595526201",
  "DT729-7022": "39763595558969",
  "DT729-7035": "39763595591737",
  "DT729-7036": "39763595624505",
  "DT729-7037": "39763595657273",
  "DT729-9005": "39763595460665",
  "DT729-9006": "39763595690041",
  "DT729-9010": "39763595722809",
  "DT729-9016": "39763595755577",
  "DT729-TB": "39763595427897",
  "DT729-TBA": "39763595788345",
  "DT761-7016": "31719266123833",
  "DT761-7021": "31719266156601",
  "DT761-7022": "31719266189369",
  "DT761-7035": "31719266222137",
  "DT761-7036": "31719266254905",
  "DT761-7037": "31719266287673",
  "DT761-9005": "31719266091065",
  "DT761-9006": "31719266320441",
  "DT761-9010": "31719266353209",
  "DT761-9016": "31719266385977",
  "DT761-TB": "31719266058297",
  "DT761-TBA": "31719266418745",
  "DT7611-7016": "31719377010745",
  "DT7611-7021": "31719377076281",
  "DT7611-7022": "31719377141817",
  "DT7611-7035": "31719377174585",
  "DT7611-7036": "31719377207353",
  "DT7611-7037": "31719377240121",
  "DT7611-9005": "31719376945209",
  "DT7611-9006": "31719377272889",
  "DT7611-9010": "31719377305657",
  "DT7611-9016": "31719377338425",
  "DT7611-TB": "31719376879673",
  "DT7611-TBA": "31719377371193",
  "DT7612-7016": "31719381991481",
  "DT7612-7021": "31719382024249",
  "DT7612-7022": "31719382057017",
  "DT7612-7035": "31719382089785",
  "DT7612-7036": "31719382122553",
  "DT7612-7037": "31719382155321",
  "DT7612-9005": "31719381958713",
  "DT7612-9006": "31719382188089",
  "DT7612-9010": "31719382220857",
  "DT7612-9016": "31719382253625",
  "DT7612-TB": "31719381925945",
  "DT7612-TBA": "31719382286393",
  "DT761NE-7016": "31718843646009",
  "DT761NE-7021": "31718843678777",
  "DT761NE-7022": "31718843711545",
  "DT761NE-7035": "31718843744313",
  "DT761NE-7036": "31718843777081",
  "DT761NE-7037": "31718843809849",
  "DT761NE-9005": "31718843613241",
  "DT761NE-9006": "31718843842617",
  "DT761NE-9010": "31718843875385",
  "DT761NE-9016": "31718843908153",
  "DT761NE-TB": "31718843580473",
  "DT761NE-TBA": "31718843940921",
  "DT764-7016": "31719303643193",
  "DT764-7021": "31719303675961",
  "DT764-7022": "31719303708729",
  "DT764-7035": "31719303741497",
  "DT764-7036": "31719303774265",
  "DT764-7037": "31719303807033",
  "DT764-9005": "31719303610425",
  "DT764-9006": "31719303839801",
  "DT764-9010": "31719303872569",
  "DT764-9016": "31719303905337",
  "DT764-TB": "31719303577657",
  "DT764-TBA": "31719303938105",
  "DT764NE-7016": "31719311441977",
  "DT764NE-7021": "31719311474745",
  "DT764NE-7022": "31719311507513",
  "DT764NE-7035": "31719311540281",
  "DT764NE-7036": "31719311573049",
  "DT764NE-7037": "31719311605817",
  "DT764NE-9005": "31719311409209",
  "DT764NE-9006": "31719311638585",
  "DT764NE-9010": "31719311671353",
  "DT764NE-9016": "31719311704121",
  "DT764NE-TB": "31719311376441",
  "DT764NE-TBA": "31719311736889",
  "DT7651-7016": "39761792401465",
  "DT7651-7021": "39761792467001",
  "DT7651-7022": "39761792532537",
  "DT7651-7035": "39761792598073",
  "DT7651-7036": "39761792663609",
  "DT7651-7037": "39761792729145",
  "DT7651-9005": "39761792303161",
  "DT7651-9006": "39761792794681",
  "DT7651-9010": "39761792860217",
  "DT7651-9016": "39761792925753",
  "DT7651-TB": "39761792237625",
  "DT7651-TBA": "39761792991289",
  "DT7652-7016": "31719316684857",
  "DT7652-7021": "31719316717625",
  "DT7652-7022": "31719316750393",
  "DT7652-7035": "31719316783161",
  "DT7652-7036": "31719316815929",
  "DT7652-7037": "31719316848697",
  "DT7652-9005": "31719316652089",
  "DT7652-9006": "31719316881465",
  "DT7652-9010": "31719316914233",
  "DT7652-9016": "31719316947001",
  "DT7652-TB": "31719316619321",
  "DT7652-TBA": "31719316979769",
  "DT7655-7016": "39761792335929",
  "DT7655-7021": "39761792434233",
  "DT7655-7022": "39761792499769",
  "DT7655-7035": "39761792565305",
  "DT7655-7036": "39761792630841",
  "DT7655-7037": "39761792696377",
  "DT7655-9005": "39761792270393",
  "DT7655-9006": "39761792761913",
  "DT7655-9010": "39761792827449",
  "DT7655-9016": "39761792892985",
  "DT7655-TB": "39761792204857",
  "DT7655-TBA": "39761792958521",
  "DT766-7016": "31719344504889",
  "DT766-7021": "31719344537657",
  "DT766-7022": "31719344570425",
  "DT766-7035": "31719344603193",
  "DT766-7036": "31719344635961",
  "DT766-7037": "31719344668729",
  "DT766-9005": "31719344472121",
  "DT766-9006": "31719344701497",
  "DT766-9010": "31719344734265",
  "DT766-9016": "31719344799801",
  "DT766-TB": "31719344439353",
  "DT766-TBA": "31719344865337",
  "DT767-7016": "39761717821497",
  "DT767-7021": "39761717854265",
  "DT767-7022": "39761717919801",
  "DT767-7035": "39761717952569",
  "DT767-7036": "39761717985337",
  "DT767-7037": "39761718018105",
  "DT767-9005": "39761717788729",
  "DT767-9006": "39761718050873",
  "DT767-9010": "39761718083641",
  "DT767-9016": "39761718116409",
  "DT767-TB": "39761717755961",
  "DT767-TBA": "39761718149177",
  "DT768-7016": "31719357022265",
  "DT768-7021": "31719357055033",
  "DT768-7022": "31719357087801",
  "DT768-7035": "31719357120569",
  "DT768-7036": "31719357153337",
  "DT768-7037": "31719357186105",
  "DT768-9005": "31719356989497",
  "DT768-9006": "31719357218873",
  "DT768-9010": "31719357251641",
  "DT768-9016": "31719357284409",
  "DT768-TB": "31719356956729",
  "DT768-TBA": "31719357317177",
  "DT769-7016": "39761823236153",
  "DT769-7021": "39761823268921",
  "DT769-7022": "39761823301689",
  "DT769-7035": "39761823334457",
  "DT769-7036": "39761823367225",
  "DT769-7037": "39761823399993",
  "DT769-9005": "39761823203385",
  "DT769-9006": "39761823432761",
  "DT769-9010": "39761823465529",
  "DT769-9016": "39761823498297",
  "DT769-TB": "39761823170617",
  "DT769-TBA": "39761823531065",
  "GB1-7016": "31699362906169",
  "GB1-7021": "31699362938937",
  "GB1-7022": "31699362971705",
  "GB1-7035": "31699363070009",
  "GB1-7036": "31699363102777",
  "GB1-7037": "31699363135545",
  "GB1-9005": "31699362873401",
  "GB1-9006": "31699363168313",
  "GB1-9010": "31699363201081",
  "GB1-9016": "31699363233849",
  "GB1-TB": "31699362840633",
  "GB1-TBA": "31703797137465",
  "GB10-7016": "31699471401017",
  "GB10-7021": "31699471433785",
  "GB10-7022": "31699471466553",
  "GB10-7035": "31699471499321",
  "GB10-7036": "31699471761465",
  "GB10-7037": "31699471794233",
  "GB10-9005": "31699471368249",
  "GB10-9006": "31699471827001",
  "GB10-9010": "31699471859769",
  "GB10-9016": "31699471892537",
  "GB10-TB": "31699471335481",
  "GB10-TBA": "31703798841401",
  "GB11-7016": "31699585957945",
  "GB11-7021": "31699585990713",
  "GB11-7022": "31699586056249",
  "GB11-7035": "31699586089017",
  "GB11-7036": "31699586121785",
  "GB11-7037": "31699586154553",
  "GB11-9005": "31699585892409",
  "GB11-9006": "31699586187321",
  "GB11-9010": "31699586220089",
  "GB11-9016": "31699586252857",
  "GB11-TB": "31699585859641",
  "GB11-TBA": "31703801102393",
  "GB2-7016": "31699399114809",
  "GB2-7021": "31699399147577",
  "GB2-7022": "31699399180345",
  "GB2-7035": "31699399213113",
  "GB2-7036": "31699399245881",
  "GB2-7037": "31699399278649",
  "GB2-9005": "31699399082041",
  "GB2-9006": "31699399311417",
  "GB2-9010": "31699399344185",
  "GB2-9016": "31699399376953",
  "GB2-TB": "31699399049273",
  "GB2-TBA": "31703802282041",
  "GB6-7016": "31699427459129",
  "GB6-7021": "31699427491897",
  "GB6-7022": "31699427524665",
  "GB6-7035": "31699427557433",
  "GB6-7036": "31699427590201",
  "GB6-7037": "31699427622969",
  "GB6-9005": "31699427426361",
  "GB6-9006": "31699427655737",
  "GB6-9010": "31699427688505",
  "GB6-9016": "31699427721273",
  "GB6-TB": "31699427393593",
  "GB6-TBA": "31703804313657",
  "GB7-7016": "31699445088313",
  "GB7-7021": "31699445121081",
  "GB7-7022": "31699445153849",
  "GB7-7035": "31699445186617",
  "GB7-7036": "31699445219385",
  "GB7-7037": "31699445252153",
  "GB7-9005": "31699445055545",
  "GB7-9006": "31699445284921",
  "GB7-9010": "31699445317689",
  "GB7-9016": "31699445350457",
  "GB7-TB": "31699445022777",
  "GB7-TBA": "31703805132857",
  "GB8-7016": "31699452362809",
  "GB8-7021": "31699452395577",
  "GB8-7022": "31699452428345",
  "GB8-7035": "31699452461113",
  "GB8-7036": "31699452493881",
  "GB8-7037": "31699452526649",
  "GB8-9005": "31699452330041",
  "GB8-9006": "31699452559417",
  "GB8-9010": "31699452592185",
  "GB8-9016": "31699452624953",
  "GB8-TB": "31699452297273",
  "GB8-TBA": "31703811948601",
  "GB9-7016": "31699463667769",
  "GB9-7021": "31699463700537",
  "GB9-7022": "31699463733305",
  "GB9-7035": "31699463766073",
  "GB9-7036": "31699463798841",
  "GB9-7037": "31699463831609",
  "GB9-9005": "31699463635001",
  "GB9-9006": "31699463864377",
  "GB9-9010": "31699463897145",
  "GB9-9016": "31699463929913",
  "GB9-TB": "31699463602233",
  "GB9-TBA": "31703816110137",
  "GD1-7016": "31698642370617",
  "GD1-7021": "31698642403385",
  "GD1-7022": "31698642436153",
  "GD1-7035": "31698642468921",
  "GD1-7036": "31698642501689",
  "GD1-7037": "31698642534457",
  "GD1-9005": "31698642337849",
  "GD1-9006": "31698642567225",
  "GD1-9010": "31698642599993",
  "GD1-9016": "31698642632761",
  "GD1-TB": "31698642305081",
  "GD1-TBA": "31703830396985",
  "GD10-7016": "31698694078521",
  "GD10-7021": "31698694111289",
  "GD10-7022": "31698694144057",
  "GD10-7035": "31698694176825",
  "GD10-7036": "31698694209593",
  "GD10-7037": "31698694242361",
  "GD10-9005": "31698694045753",
  "GD10-9006": "31698694275129",
  "GD10-9010": "31698694307897",
  "GD10-9016": "31698694340665",
  "GD10-TB": "31698694012985",
  "GD10-TBA": "31703832297529",
  "GD12-7016": "31802940162105",
  "GD12-7021": "31802940194873",
  "GD12-7022": "31802940227641",
  "GD12-7035": "31802940260409",
  "GD12-7036": "31802940293177",
  "GD12-7037": "31802940325945",
  "GD12-9005": "31802940129337",
  "GD12-9006": "31802940358713",
  "GD12-9010": "31802940391481",
  "GD12-9016": "31802940424249",
  "GD12-TB": "31802940096569",
  "GD12-TBA": "31802940457017",
  "GD2-7016": "31698661933113",
  "GD2-7021": "31698661965881",
  "GD2-7022": "31698661998649",
  "GD2-7035": "31698662031417",
  "GD2-7036": "31698662064185",
  "GD2-7037": "31698662096953",
  "GD2-9005": "31698661900345",
  "GD2-9006": "31698662129721",
  "GD2-9010": "31698662162489",
  "GD2-9016": "31698662195257",
  "GD2-TB": "31698661867577",
  "GD2-TBA": "31703835312185",
  "GD3-7016": "31698669338681",
  "GD3-7021": "31698669371449",
  "GD3-7022": "31698669404217",
  "GD3-7035": "31698669436985",
  "GD3-7036": "31698669469753",
  "GD3-7037": "31698669502521",
  "GD3-9005": "31698669305913",
  "GD3-9006": "31698669535289",
  "GD3-9010": "31698669568057",
  "GD3-9016": "31698669600825",
  "GD3-TB": "31698669273145",
  "GD3-TBA": "31703836655673",
  "GD4-7016": "31698674909241",
  "GD4-7021": "31698674974777",
  "GD4-7022": "31698675007545",
  "GD4-7035": "31698675040313",
  "GD4-7036": "31698675073081",
  "GD4-7037": "31698675105849",
  "GD4-9005": "31698674876473",
  "GD4-9006": "31698675138617",
  "GD4-9010": "31698675171385",
  "GD4-9016": "31698675204153",
  "GD4-TB": "31698674843705",
  "GD4-TBA": "31703838818361",
  "GD5-7016": "31698680283193",
  "GD5-7021": "31698680315961",
  "GD5-7022": "31698680348729",
  "GD5-7035": "31698680381497",
  "GD5-7036": "31698680414265",
  "GD5-7037": "31698680447033",
  "GD5-9005": "31698680250425",
  "GD5-9006": "31698680479801",
  "GD5-9010": "31698680512569",
  "GD5-9016": "31698680545337",
  "GD5-TB": "31698680217657",
  "GD5-TBA": "31703839735865",
  "GD6-7016": "31698684379193",
  "GD6-7021": "31698684411961",
  "GD6-7022": "31698684444729",
  "GD6-7035": "31698684477497",
  "GD6-7036": "31698684510265",
  "GD6-7037": "31698684543033",
  "GD6-9005": "31698684346425",
  "GD6-9006": "31698684575801",
  "GD6-9010": "31698684608569",
  "GD6-9016": "31698684641337",
  "GD6-TB": "31698684313657",
  "GD6-TBA": "31703841964089",
  "GD7-7016": "31698688507961",
  "GD7-7021": "31698688540729",
  "GD7-7022": "31698688573497",
  "GD7-7035": "31698688606265",
  "GD7-7036": "31698688639033",
  "GD7-7037": "31698688671801",
  "GD7-9005": "31698688475193",
  "GD7-9006": "31698688704569",
  "GD7-9010": "31698688737337",
  "GD7-9016": "31698688770105",
  "GD7-TB": "31698688442425",
  "GD7-TBA": "31703844028473",
  "GD8-7016": "31698690572345",
  "GD8-7021": "31698690605113",
  "GD8-7022": "31698690637881",
  "GD8-7035": "31698690670649",
  "GD8-7036": "31698690703417",
  "GD8-7037": "31698690736185",
  "GD8-9005": "31698690539577",
  "GD8-9006": "31698690768953",
  "GD8-9010": "31698690801721",
  "GD8-9016": "31698690834489",
  "GD8-TB": "31698690506809",
  "GD8-TBA": "31703846912057",
  "GD9-7016": "31698691883065",
  "GD9-7021": "31698691915833",
  "GD9-7022": "31698691948601",
  "GD9-7035": "31698691981369",
  "GD9-7036": "31698692014137",
  "GD9-7037": "31698692046905",
  "GD9-9005": "31698691850297",
  "GD9-9006": "31698692079673",
  "GD9-9010": "31698692112441",
  "GD9-9016": "31698692145209",
  "GD9-TB": "31698691817529",
  "GD9-TBA": "31703848779833",
  "GHR1-7016": "31694035615801",
  "GHR1-7021": "31694035681337",
  "GHR1-7022": "31694134706233",
  "GHR1-7035": "31694138736697",
  "GHR1-7036": "31694147846201",
  "GHR1-7037": "31694149713977",
  "GHR1-9005": "31694035583033",
  "GHR1-9006": "31694154104889",
  "GHR1-9010": "31694035648569",
  "GHR1-9016": "31694150991929",
  "GHR1-TB": "31694155776057",
  "GHR1-TBA": "31703851860025",
  "GHR10-7016": "31698298044473",
  "GHR10-7021": "31698298077241",
  "GHR10-7022": "31698298110009",
  "GHR10-7035": "31698298142777",
  "GHR10-7036": "31698298175545",
  "GHR10-7037": "31698298208313",
  "GHR10-9005": "31698298011705",
  "GHR10-9006": "31698298241081",
  "GHR10-9010": "31698298273849",
  "GHR10-9016": "31698298306617",
  "GHR10-TB": "31698297978937",
  "GHR10-TBA": "31703852384313",
  "GHR12-7016": "31802902839353",
  "GHR12-7021": "31802902872121",
  "GHR12-7022": "31802902904889",
  "GHR12-7035": "31802902937657",
  "GHR12-7036": "31802902970425",
  "GHR12-7037": "31802903003193",
  "GHR12-9005": "31802902806585",
  "GHR12-9006": "31802903035961",
  "GHR12-9010": "31802903068729",
  "GHR12-9016": "31802903101497",
  "GHR12-TB": "31802902773817",
  "GHR12-TBA": "31802903134265",
  "GHR2-7016": "31694164820025",
  "GHR2-7021": "31694164852793",
  "GHR2-7022": "31694164885561",
  "GHR2-7035": "31694164918329",
  "GHR2-7036": "31694164951097",
  "GHR2-7037": "31694164983865",
  "GHR2-9005": "31694164787257",
  "GHR2-9006": "31694165016633",
  "GHR2-9010": "31694165049401",
  "GHR2-9016": "31694165082169",
  "GHR2-TB": "31694164754489",
  "GHR2-TBA": "31703855824953",
  "GHR3-7016": "31697985142841",
  "GHR3-7021": "31697985175609",
  "GHR3-7022": "31697985208377",
  "GHR3-7035": "31697985241145",
  "GHR3-7036": "31697985273913",
  "GHR3-7037": "31697985306681",
  "GHR3-9005": "31697985110073",
  "GHR3-9006": "31697985339449",
  "GHR3-9010": "31697985372217",
  "GHR3-9016": "31697985404985",
  "GHR3-TB": "31697985077305",
  "GHR3-TBA": "31703857823801",
  "GHR4-7016": "31694195458105",
  "GHR4-7021": "31694195490873",
  "GHR4-7022": "31694195523641",
  "GHR4-7035": "31694195556409",
  "GHR4-7036": "31694195589177",
  "GHR4-7037": "31694195621945",
  "GHR4-9005": "31694195425337",
  "GHR4-9006": "31694195654713",
  "GHR4-9010": "31694195687481",
  "GHR4-9016": "31694195720249",
  "GHR4-TB": "31694195392569",
  "GHR4-TBA": "31703859986489",
  "GHR5-7016": "31697949818937",
  "GHR5-7021": "31697949851705",
  "GHR5-7022": "31697949884473",
  "GHR5-7035": "31697949917241",
  "GHR5-7036": "31697949950009",
  "GHR5-7037": "31697949982777",
  "GHR5-9005": "31697949786169",
  "GHR5-9006": "31697950015545",
  "GHR5-9010": "31697950048313",
  "GHR5-9016": "31697950081081",
  "GHR5-TB": "31697949720633",
  "GHR5-TBA": "31703861002297",
  "GHR6-7016": "31698263605305",
  "GHR6-7021": "31698263638073",
  "GHR6-7022": "31698263670841",
  "GHR6-7035": "31698263703609",
  "GHR6-7036": "31698263736377",
  "GHR6-7037": "31698263769145",
  "GHR6-9005": "31698263572537",
  "GHR6-9006": "31698263801913",
  "GHR6-9010": "31698263834681",
  "GHR6-9016": "31698263867449",
  "GHR6-TB": "31698263539769",
  "GHR6-TBA": "31703863164985",
  "GHR7-7016": "31698284609593",
  "GHR7-7021": "31698284642361",
  "GHR7-7022": "31698284707897",
  "GHR7-7035": "31698284740665",
  "GHR7-7036": "31698284773433",
  "GHR7-7037": "31698284806201",
  "GHR7-9005": "31698284576825",
  "GHR7-9006": "31698284838969",
  "GHR7-9010": "31698284871737",
  "GHR7-9016": "31698284904505",
  "GHR7-TB": "31698284544057",
  "GHR7-TBA": "31703864442937",
  "GHR8-7016": "31698287919161",
  "GHR8-7021": "31698287951929",
  "GHR8-7022": "31698287984697",
  "GHR8-7035": "31698288017465",
  "GHR8-7036": "31698288050233",
  "GHR8-7037": "31698288083001",
  "GHR8-9005": "31698287886393",
  "GHR8-9006": "31698288115769",
  "GHR8-9010": "31698288148537",
  "GHR8-9016": "31698288181305",
  "GHR8-TB": "31698287853625",
  "GHR8-TBA": "31703865884729",
  "GHR9-7016": "31698294407225",
  "GHR9-7021": "31698294439993",
  "GHR9-7022": "31698294472761",
  "GHR9-7035": "31698294505529",
  "GHR9-7036": "31698294538297",
  "GHR9-7037": "31698294571065",
  "GHR9-9005": "31698294374457",
  "GHR9-9006": "31698294603833",
  "GHR9-9010": "31698294636601",
  "GHR9-9016": "31698294669369",
  "GHR9-TB": "31698294341689",
  "GHR9-TBA": "31703869521977",
  "GTM1-7016": "31703511072825",
  "GTM1-7021": "31703511105593",
  "GTM1-7022": "31703511138361",
  "GTM1-7035": "31703511171129",
  "GTM1-7036": "31703511203897",
  "GTM1-7037": "31703511236665",
  "GTM1-9005": "31703511040057",
  "GTM1-9006": "31703511269433",
  "GTM1-9010": "31703511302201",
  "GTM1-9016": "31703511334969",
  "GTM1-TB": "31703511007289",
  "GTM1-TBA": "31703871782969",
  "GTM10-7016": "31704959418425",
  "GTM10-7021": "31704959451193",
  "GTM10-7022": "31704959483961",
  "GTM10-7035": "31704959516729",
  "GTM10-7036": "31704959549497",
  "GTM10-7037": "31704959582265",
  "GTM10-9005": "31704959385657",
  "GTM10-9006": "31704959615033",
  "GTM10-9010": "31704959680569",
  "GTM10-9016": "31704959713337",
  "GTM10-TB": "31704959352889",
  "GTM10-TBA": "31704959746105",
  "GTM11-7016": "31704966332473",
  "GTM11-7021": "31704966365241",
  "GTM11-7022": "31704966398009",
  "GTM11-7035": "31704966430777",
  "GTM11-7036": "31704966463545",
  "GTM11-7037": "31704966496313",
  "GTM11-9005": "31704966299705",
  "GTM11-9006": "31704966529081",
  "GTM11-9010": "31704966561849",
  "GTM11-9016": "31704966594617",
  "GTM11-TB": "31704966266937",
  "GTM12-7016": "31704976752697",
  "GTM12-7021": "31704976818233",
  "GTM12-7022": "31704976883769",
  "GTM12-7035": "31704976949305",
  "GTM12-7036": "31704976982073",
  "GTM12-7037": "31704977014841",
  "GTM12-9005": "31704976719929",
  "GTM12-9006": "31704977047609",
  "GTM12-9010": "31704977080377",
  "GTM12-9016": "31704977113145",
  "GTM12-TB": "31704976687161",
  "GTM12-TBA": "31704977145913",
  "GTM13-7016": "31704999690297",
  "GTM13-7021": "31704999755833",
  "GTM13-7022": "31704999821369",
  "GTM13-7035": "31704999854137",
  "GTM13-7036": "31704999919673",
  "GTM13-7037": "31704999952441",
  "GTM13-9005": "31704999657529",
  "GTM13-9006": "31705000017977",
  "GTM13-9010": "31705000083513",
  "GTM13-9016": "31705000149049",
  "GTM13-TB": "31704999591993",
  "GTM13-TBA": "31705000214585",
  "GTM14-7016": "31705032327225",
  "GTM14-7021": "31705032359993",
  "GTM14-7022": "31705032392761",
  "GTM14-7035": "31705032425529",
  "GTM14-7036": "31705032458297",
  "GTM14-7037": "31705032491065",
  "GTM14-9005": "31705032294457",
  "GTM14-9006": "31705032523833",
  "GTM14-9010": "31705032556601",
  "GTM14-9016": "31705032589369",
  "GTM14-TB": "31705032261689",
  "GTM14-TBA": "31705032622137",
  "GTM15-7016": "31705042321465",
  "GTM15-7021": "31705042354233",
  "GTM15-7022": "31705042387001",
  "GTM15-7035": "31705042419769",
  "GTM15-7036": "31705042452537",
  "GTM15-7037": "31705042485305",
  "GTM15-9005": "31705042288697",
  "GTM15-9006": "31705042518073",
  "GTM15-9010": "31705042550841",
  "GTM15-9016": "31705042583609",
  "GTM15-TB": "31705042255929",
  "GTM15-TBA": "31705042616377",
  "GTM16-7016": "31802942750777",
  "GTM16-7021": "31802942783545",
  "GTM16-7022": "31802942816313",
  "GTM16-7035": "31802942849081",
  "GTM16-7036": "31802942881849",
  "GTM16-7037": "31802942914617",
  "GTM16-9005": "31802942718009",
  "GTM16-9006": "31802942947385",
  "GTM16-9010": "31802942980153",
  "GTM16-9016": "31802943012921",
  "GTM16-TB": "31802942685241",
  "GTM16-TBA": "31802943045689",
  "GTM2-7016": "31703541841977",
  "GTM2-7021": "31703541874745",
  "GTM2-7022": "31703541907513",
  "GTM2-7035": "31703541940281",
  "GTM2-7036": "31703541973049",
  "GTM2-7037": "31703542005817",
  "GTM2-9005": "31703541809209",
  "GTM2-9006": "31703542038585",
  "GTM2-9010": "31703542071353",
  "GTM2-9016": "31703542104121",
  "GTM2-TB": "31703541776441",
  "GTM2-TBA": "31703872503865",
  "GTM3-7016": "31703555768377",
  "GTM3-7021": "31703555801145",
  "GTM3-7022": "31703555833913",
  "GTM3-7035": "31703555866681",
  "GTM3-7036": "31703555899449",
  "GTM3-7037": "31703555932217",
  "GTM3-9005": "31703555735609",
  "GTM3-9006": "31703555964985",
  "GTM3-9010": "31703555997753",
  "GTM3-9016": "31703556030521",
  "GTM3-TB": "31703555702841",
  "GTM3-TBA": "31703873552441",
  "GTM4-7016": "31703562551353",
  "GTM4-7021": "31703562584121",
  "GTM4-7022": "31703562616889",
  "GTM4-7035": "31703562649657",
  "GTM4-7036": "31703562682425",
  "GTM4-7037": "31703562715193",
  "GTM4-9005": "31703562518585",
  "GTM4-9006": "31703562747961",
  "GTM4-9010": "31703562780729",
  "GTM4-9016": "31703562813497",
  "GTM4-TB": "31703562485817",
  "GTM4-TBA": "31703874699321",
  "GTM5-7016": "31704888901689",
  "GTM5-7021": "31704888934457",
  "GTM5-7022": "31704888967225",
  "GTM5-7035": "31704888999993",
  "GTM5-7036": "31704889032761",
  "GTM5-7037": "31704889065529",
  "GTM5-9005": "31704888868921",
  "GTM5-9006": "31704889098297",
  "GTM5-9010": "31704889131065",
  "GTM5-9016": "31704889163833",
  "GTM5-TB": "31704888836153",
  "GTM5-TBA": "31704889196601",
  "GTM6-7016": "31704902893625",
  "GTM6-7021": "31704902959161",
  "GTM6-7022": "31704902991929",
  "GTM6-7035": "31704903057465",
  "GTM6-7036": "31704903090233",
  "GTM6-7037": "31704903155769",
  "GTM6-9005": "31704902860857",
  "GTM6-9006": "31704903188537",
  "GTM6-9010": "31704903254073",
  "GTM6-9016": "31704903286841",
  "GTM6-TB": "31704902795321",
  "GTM6-TBA": "31704903352377",
  "GTM7-7016": "31704908038201",
  "GTM7-7021": "31704908070969",
  "GTM7-7022": "31704908103737",
  "GTM7-7035": "31704908136505",
  "GTM7-7036": "31704908169273",
  "GTM7-7037": "31704908202041",
  "GTM7-9005": "31704908005433",
  "GTM7-9006": "31704908234809",
  "GTM7-9010": "31704908267577",
  "GTM7-9016": "31704908300345",
  "GTM7-TB": "31704907972665",
  "GTM7-TBA": "31704908333113",
  "GTM8-7016": "31704944771129",
  "GTM8-7021": "31704944803897",
  "GTM8-7022": "31704944836665",
  "GTM8-7035": "31704944869433",
  "GTM8-7036": "31704944902201",
  "GTM8-7037": "31704944934969",
  "GTM8-9005": "31704944705593",
  "GTM8-9006": "31704944967737",
  "GTM8-9010": "31704945000505",
  "GTM8-9016": "31704945033273",
  "GTM8-TB": "31704944672825",
  "GTM8-TBA": "31704945098809",
  "GTM9-7016": "31704955355193",
  "GTM9-7021": "31704955387961",
  "GTM9-7022": "31704955453497",
  "GTM9-7035": "31704955486265",
  "GTM9-7036": "31704955519033",
  "GTM9-7037": "31704955551801",
  "GTM9-9005": "31704955322425",
  "GTM9-9006": "31704955584569",
  "GTM9-9010": "31704955617337",
  "GTM9-9016": "31704955682873",
  "GTM9-TB": "31704955289657",
  "GTM9-TBA": "31704955715641",
  "LF1-7016": "31727851470905",
  "LF1-7021": "31727851503673",
  "LF1-7022": "31727851536441",
  "LF1-7035": "31727851569209",
  "LF1-7036": "31727851601977",
  "LF1-7037": "31727851634745",
  "LF1-9005": "31727851438137",
  "LF1-9006": "31727851667513",
  "LF1-9010": "31727851700281",
  "LF1-9016": "31727851733049",
  "LF1-TB": "31727851405369",
  "LF1-TBA": "31727851765817",
  "LF150-7016": "31725032276025",
  "LF150-7021": "31725032308793",
  "LF150-7022": "31725032341561",
  "LF150-7035": "31725032374329",
  "LF150-7036": "31725032407097",
  "LF150-7037": "31725032439865",
  "LF150-9005": "31725032243257",
  "LF150-9006": "31725032472633",
  "LF150-9010": "31725032505401",
  "LF150-9016": "31725032538169",
  "LF150-TB": "31725032210489",
  "LF150-TBA": "31725032570937",
  "LF2-7016": "31727938601017",
  "LF2-7021": "31727938633785",
  "LF2-7022": "31727938666553",
  "LF2-7035": "31727938699321",
  "LF2-7036": "31727938732089",
  "LF2-7037": "31727938764857",
  "LF2-9005": "31727938568249",
  "LF2-9006": "31727938797625",
  "LF2-9010": "31727938830393",
  "LF2-9016": "31727938863161",
  "LF2-TB": "31727938535481",
  "LF2-TBA": "31727938895929",
  "LF210-7016": "31725032669241",
  "LF210-7021": "31725032702009",
  "LF210-7022": "31725032734777",
  "LF210-7035": "31725032800313",
  "LF210-7036": "31725032833081",
  "LF210-7037": "31725032865849",
  "LF210-9005": "31725032636473",
  "LF210-9006": "31725032898617",
  "LF210-9010": "31725032931385",
  "LF210-9016": "31725032964153",
  "LF210-TB": "31725032603705",
  "LF210-TBA": "31725032996921",
  "LF3-7016": "31727938994233",
  "LF3-7021": "31727939027001",
  "LF3-7022": "31727939059769",
  "LF3-7035": "31727939092537",
  "LF3-7036": "31727939125305",
  "LF3-7037": "31727939158073",
  "LF3-9005": "31727938961465",
  "LF3-9006": "31727939190841",
  "LF3-9010": "31727939223609",
  "LF3-9016": "31727939256377",
  "LF3-TB": "31727938928697",
  "LF3-TBA": "31727939289145",
  "LF335-7016": "31725033095225",
  "LF335-7021": "31725033127993",
  "LF335-7022": "31725033160761",
  "LF335-7035": "31725033193529",
  "LF335-7036": "31725033259065",
  "LF335-7037": "31725033291833",
  "LF335-9005": "31725033062457",
  "LF335-9006": "31725033324601",
  "LF335-9010": "31725033357369",
  "LF335-9016": "31725033390137",
  "LF335-TB": "31725033029689",
  "LF335-TBA": "31725033422905",
  "LF4-7016": "31727939387449",
  "LF4-7021": "31727939420217",
  "LF4-7022": "31727939452985",
  "LF4-7035": "31727939485753",
  "LF4-7036": "31727939518521",
  "LF4-7037": "31727939551289",
  "LF4-9005": "31727939354681",
  "LF4-9006": "31727939584057",
  "LF4-9010": "31727939616825",
  "LF4-9016": "31727939649593",
  "LF4-TB": "31727939321913",
  "LF4-TBA": "31727939682361",
  "LF460-7016": "31725033521209",
  "LF460-7021": "31725033553977",
  "LF460-7022": "31725033586745",
  "LF460-7035": "31725033619513",
  "LF460-7036": "31725033652281",
  "LF460-7037": "31725033685049",
  "LF460-9005": "31725033488441",
  "LF460-9006": "31725033717817",
  "LF460-9010": "31725033750585",
  "LF460-9016": "31725033783353",
  "LF460-TB": "31725033455673",
  "LF460-TBA": "31725033816121",
  "LF5-7016": "31727939780665",
  "LF5-7021": "31727939813433",
  "LF5-7022": "31727939846201",
  "LF5-7035": "31727939878969",
  "LF5-7036": "31727939911737",
  "LF5-7037": "31727939944505",
  "LF5-9005": "31727939747897",
  "LF5-9006": "31727939977273",
  "LF5-9010": "31727940010041",
  "LF5-9016": "31727940042809",
  "LF5-TB": "31727939715129",
  "LF5-TBA": "31727940075577",
  "LF6-7016": "31728016719929",
  "LF6-7021": "31728016752697",
  "LF6-7022": "31728016785465",
  "LF6-7035": "31728016818233",
  "LF6-7036": "31728016851001",
  "LF6-7037": "31728016883769",
  "LF6-9005": "31728016687161",
  "LF6-9006": "31728016916537",
  "LF6-9010": "31728016949305",
  "LF6-9016": "31728016982073",
  "LF6-TB": "31728016654393",
  "LF6-TBA": "31728017014841",
  "LF7-7016": "31728017113145",
  "LF7-7021": "31728017145913",
  "LF7-7022": "31728017178681",
  "LF7-7035": "31728017211449",
  "LF7-7036": "31728017244217",
  "LF7-7037": "31728017276985",
  "LF7-9005": "31728017080377",
  "LF7-9006": "31728017309753",
  "LF7-9010": "31728017342521",
  "LF7-9016": "31728017375289",
  "LF7-TB": "31728017047609",
  "LF7-TBA": "31728017408057",
  "SF1-7016": "31730750455865",
  "SF1-7021": "31730750488633",
  "SF1-7022": "31730750554169",
  "SF1-7035": "31730750586937",
  "SF1-7036": "31730750619705",
  "SF1-7037": "31730750652473",
  "SF1-9005": "31730750423097",
  "SF1-9006": "31730750685241",
  "SF1-9010": "31730750718009",
  "SF1-9016": "31730750750777",
  "SF1-TB": "31730750390329",
  "SF1-TBA": "31730750783545",
  "SF180-7016": "31730667159609",
  "SF180-7021": "31730667192377",
  "SF180-7022": "31730667225145",
  "SF180-7035": "31730667257913",
  "SF180-7036": "31730667290681",
  "SF180-7037": "31730667323449",
  "SF180-9005": "31730667126841",
  "SF180-9006": "31730667356217",
  "SF180-9010": "31730667388985",
  "SF180-9016": "31730667421753",
  "SF180-TB": "31730667094073",
  "SF180-TBA": "31730667454521",
  "SF2-7016": "31730750881849",
  "SF2-7021": "31730750914617",
  "SF2-7022": "31730750947385",
  "SF2-7035": "31730750980153",
  "SF2-7036": "31730751012921",
  "SF2-7037": "31730751045689",
  "SF2-9005": "31730750849081",
  "SF2-9006": "31730751078457",
  "SF2-9010": "31730751111225",
  "SF2-9016": "31730751143993",
  "SF2-TB": "31730750816313",
  "SF2-TBA": "31730751176761",
  "SF365-7016": "31730667946041",
  "SF365-7021": "31730667978809",
  "SF365-7022": "31730668011577",
  "SF365-7035": "31730668044345",
  "SF365-7036": "31730668077113",
  "SF365-7037": "31730668109881",
  "SF365-9005": "31730667913273",
  "SF365-9006": "31730668142649",
  "SF365-9010": "31730668175417",
  "SF365-9016": "31730668208185",
  "SF365-TB": "31730667880505",
  "SF365-TBA": "31730668240953",
  "SF490-7016": "31730668732473",
  "SF490-7021": "31730668765241",
  "SF490-7022": "31730668798009",
  "SF490-7035": "31730668830777",
  "SF490-7036": "31730668863545",
  "SF490-7037": "31730668896313",
  "SF490-9005": "31730668699705",
  "SF490-9006": "31730668929081",
  "SF490-9010": "31730668961849",
  "SF490-9016": "31730668994617",
  "SF490-TB": "31730668666937",
  "SF490-TBA": "31730669027385",
  "SF740-7016": "31730669518905",
  "SF740-7021": "31730669551673",
  "SF740-7022": "31730669584441",
  "SF740-7035": "31730669617209",
  "SF740-7036": "31730669649977",
  "SF740-7037": "31730669682745",
  "SF740-9005": "31730669486137",
  "SF740-9006": "31730669715513",
  "SF740-9010": "31730669748281",
  "SF740-9016": "31730669781049",
  "SF740-TB": "31730669453369",
  "SF740-TBA": "31730669813817",
  "SU1": "41106395693113",
  "SU10": "41107971997753",
  "SU11": "41106526699577",
  "SU3": "41107959775289",
  "SU4": "41107984973881",
  "SU5": "41107979599929",
  "SU6-7016": "31730781683769",
  "SU6-7021": "31730781716537",
  "SU6-7022": "31730781749305",
  "SU6-7035": "31730781782073",
  "SU6-7036": "31730781814841",
  "SU6-7037": "31730781847609",
  "SU6-9005": "31730781651001",
  "SU6-9006": "31730781880377",
  "SU6-9010": "31730781913145",
  "SU6-9016": "31730781945913",
  "SU6-TBA": "31730781978681",
  "SU7-7016": "31728058859577",
  "SU7-7021": "31728058892345",
  "SU7-7022": "31728058925113",
  "SU7-7035": "31728058957881",
  "SU7-7036": "31728058990649",
  "SU7-7037": "31728059023417",
  "SU7-9005": "31728058826809",
  "SU7-9006": "31728059056185",
  "SU7-9010": "31728059088953",
  "SU7-9016": "31728059121721",
  "SU7-TB": "31728058794041",
  "SU7-TBA": "31728059154489",
  "SU9": "41108005748793",
  "SV180-7016": "31730667552825",
  "SV180-7021": "31730667585593",
  "SV180-7022": "31730667618361",
  "SV180-7035": "31730667651129",
  "SV180-7036": "31730667683897",
  "SV180-7037": "31730667716665",
  "SV180-9005": "31730667520057",
  "SV180-9006": "31730667749433",
  "SV180-9010": "31730667782201",
  "SV180-9016": "31730667814969",
  "SV180-TB": "31730667487289",
  "SV180-TBA": "31730667847737",
  "SV365-7016": "31730668339257",
  "SV365-7021": "31730668372025",
  "SV365-7022": "31730668404793",
  "SV365-7035": "31730668437561",
  "SV365-7036": "31730668470329",
  "SV365-7037": "31730668503097",
  "SV365-9005": "31730668306489",
  "SV365-9006": "31730668535865",
  "SV365-9010": "31730668568633",
  "SV365-9016": "31730668601401",
  "SV365-TB": "31730668273721",
  "SV365-TBA": "31730668634169",
  "SV490-7016": "31730669125689",
  "SV490-7021": "31730669158457",
  "SV490-7022": "31730669191225",
  "SV490-7035": "31730669223993",
  "SV490-7036": "31730669256761",
  "SV490-7037": "31730669289529",
  "SV490-9005": "31730669092921",
  "SV490-9006": "31730669322297",
  "SV490-9010": "31730669355065",
  "SV490-9016": "31730669387833",
  "SV490-TB": "31730669060153",
  "SV490-TBA": "31730669420601",
  "SV740-7016": "31730669912121",
  "SV740-7021": "31730669944889",
  "SV740-7022": "31730669977657",
  "SV740-7035": "31730670010425",
  "SV740-7036": "31730670043193",
  "SV740-7037": "31730670075961",
  "SV740-9005": "31730669879353",
  "SV740-9006": "31730670108729",
  "SV740-9010": "31730670141497",
  "SV740-9016": "31730670174265",
  "SV740-TB": "31730669846585",
  "SV740-TBA": "31730670207033",
  "UF1-7016": "31727895085113",
  "UF1-7021": "31727895117881",
  "UF1-7022": "31727895150649",
  "UF1-7035": "31727895183417",
  "UF1-7036": "31727895216185",
  "UF1-7037": "31727895248953",
  "UF1-9005": "31727895052345",
  "UF1-9006": "31727895281721",
  "UF1-9010": "31727895314489",
  "UF1-9016": "31727895347257",
  "UF1-TB": "31727895019577",
  "UF1-TBA": "31727895380025",
  "UF150-7016": "31726047789113",
  "UF150-7021": "31726047821881",
  "UF150-7022": "31726047854649",
  "UF150-7035": "31726047887417",
  "UF150-7036": "31726047920185",
  "UF150-7037": "31726047952953",
  "UF150-9005": "31726047756345",
  "UF150-9006": "31726047985721",
  "UF150-9010": "31726048018489",
  "UF150-9016": "31726048051257",
  "UF150-TB": "31726047723577",
  "UF150-TBA": "31726048084025",
  "UF2-7016": "31727928541241",
  "UF2-7021": "31727928574009",
  "UF2-7022": "31727928606777",
  "UF2-7035": "31727928639545",
  "UF2-7036": "31727928672313",
  "UF2-7037": "31727928705081",
  "UF2-9005": "31727928508473",
  "UF2-9006": "31727928737849",
  "UF2-9010": "31727928770617",
  "UF2-9016": "31727928803385",
  "UF2-TB": "31727928475705",
  "UF2-TBA": "31727928836153",
  "UF235-7016": "31726048182329",
  "UF235-7021": "31726048215097",
  "UF235-7022": "31726048247865",
  "UF235-7035": "31726048280633",
  "UF235-7036": "31726048313401",
  "UF235-7037": "31726048346169",
  "UF235-9005": "31726048149561",
  "UF235-9006": "31726048378937",
  "UF235-9010": "31726048411705",
  "UF235-9016": "31726048444473",
  "UF235-TB": "31726048116793",
  "UF235-TBA": "31726048477241",
  "UF3-7016": "31727928934457",
  "UF3-7021": "31727928967225",
  "UF3-7022": "31727928999993",
  "UF3-7035": "31727929032761",
  "UF3-7036": "31727929065529",
  "UF3-7037": "31727929098297",
  "UF3-9005": "31727928901689",
  "UF3-9006": "31727929131065",
  "UF3-9010": "31727929163833",
  "UF3-9016": "31727929196601",
  "UF3-TB": "31727928868921",
  "UF3-TBA": "31727929229369",
  "UF310-7016": "31726048575545",
  "UF310-7021": "31726048608313",
  "UF310-7022": "31726048641081",
  "UF310-7035": "31726048673849",
  "UF310-7036": "31726048706617",
  "UF310-7037": "31726048739385",
  "UF310-9005": "31726048542777",
  "UF310-9006": "31726048772153",
  "UF310-9010": "31726048804921",
  "UF310-9016": "31726048837689",
  "UF310-TB": "31726048510009",
  "UF310-TBA": "31726048870457",
  "UF4-7016": "31727929360441",
  "UF4-7021": "31727929393209",
  "UF4-7022": "31727929425977",
  "UF4-7035": "31727929458745",
  "UF4-7036": "31727929491513",
  "UF4-7037": "31727929524281",
  "UF4-9005": "31727929327673",
  "UF4-9006": "31727929557049",
  "UF4-9010": "31727929589817",
  "UF4-9016": "31727929622585",
  "UF4-TB": "31727929262137",
  "UF4-TBA": "31727929655353",
  "UF435-7016": "31726048968761",
  "UF435-7021": "31726049001529",
  "UF435-7022": "31726049034297",
  "UF435-7035": "31726049067065",
  "UF435-7036": "31726049132601",
  "UF435-7037": "31726049165369",
  "UF435-9005": "31726048935993",
  "UF435-9006": "31726049198137",
  "UF435-9010": "31726049230905",
  "UF435-9016": "31726049263673",
  "UF435-TB": "31726048903225",
  "UF435-TBA": "31726049296441",
  "UF5-7016": "31727929753657",
  "UF5-7021": "31727929786425",
  "UF5-7022": "31727929819193",
  "UF5-7035": "31727929851961",
  "UF5-7036": "31727929884729",
  "UF5-7037": "31727929917497",
  "UF5-9005": "31727929720889",
  "UF5-9006": "31727929950265",
  "UF5-9010": "31727929983033",
  "UF5-9016": "31727930015801",
  "UF5-TB": "31727929688121",
  "UF5-TBA": "31727930048569",
  "UF6-7016": "31728039166009",
  "UF6-7021": "31728039198777",
  "UF6-7022": "31728039231545",
  "UF6-7035": "31728039264313",
  "UF6-7036": "31728039297081",
  "UF6-7037": "31728039329849",
  "UF6-9005": "31728039133241",
  "UF6-9006": "31728039362617",
  "UF6-9010": "31728039395385",
  "UF6-9016": "31728039428153",
  "UF6-TB": "31728039100473",
  "UF6-TBA": "31728039460921",
  "UF7-7016": "31728039559225",
  "UF7-7021": "31728039591993",
  "UF7-7022": "31728039624761",
  "UF7-7035": "31728039657529",
  "UF7-7036": "31728039690297",
  "UF7-7037": "31728039723065",
  "UF7-9005": "31728039526457",
  "UF7-9006": "31728039755833",
  "UF7-9010": "31728039788601",
  "UF7-9016": "31728039821369",
  "UF7-TB": "31728039493689",
  "UF7-TBA": "31728039854137",
  "VF1-7016": "31727869657145",
  "VF1-7021": "31727869689913",
  "VF1-7022": "31727869722681",
  "VF1-7035": "31727869755449",
  "VF1-7036": "31727869788217",
  "VF1-7037": "31727869820985",
  "VF1-9005": "31727869624377",
  "VF1-9006": "31727869853753",
  "VF1-9010": "31727869886521",
  "VF1-9016": "31727869919289",
  "VF1-TB": "31727869591609",
  "VF1-TBA": "31727869952057",
  "VF165-7016": "31725718929465",
  "VF165-7021": "31725718962233",
  "VF165-7022": "31725718995001",
  "VF165-7035": "31725719027769",
  "VF165-7036": "31725719060537",
  "VF165-7037": "31725719093305",
  "VF165-9005": "31725718896697",
  "VF165-9006": "31725719126073",
  "VF165-9010": "31725719158841",
  "VF165-9016": "31725719191609",
  "VF165-TB": "31725718863929",
  "VF165-TBA": "31725719224377",
  "VF2-7016": "31727936471097",
  "VF2-7021": "31727936503865",
  "VF2-7022": "31727936536633",
  "VF2-7035": "31727936569401",
  "VF2-7036": "31727936634937",
  "VF2-7037": "31727936667705",
  "VF2-9005": "31727936438329",
  "VF2-9006": "31727936700473",
  "VF2-9010": "31727936733241",
  "VF2-9016": "31727936766009",
  "VF2-TB": "31727936405561",
  "VF2-TBA": "31727936798777",
  "VF250-7016": "31725719322681",
  "VF250-7021": "31725719355449",
  "VF250-7022": "31725719388217",
  "VF250-7035": "31725719420985",
  "VF250-7036": "31725719453753",
  "VF250-7037": "31725719486521",
  "VF250-9005": "31725719289913",
  "VF250-9006": "31725719519289",
  "VF250-9010": "31725719552057",
  "VF250-9016": "31725719584825",
  "VF250-TB": "31725719257145",
  "VF250-TBA": "31725719617593",
  "VF3-7016": "31727936897081",
  "VF3-7021": "31727936929849",
  "VF3-7022": "31727936962617",
  "VF3-7035": "31727936995385",
  "VF3-7036": "31727937028153",
  "VF3-7037": "31727937060921",
  "VF3-9005": "31727936864313",
  "VF3-9006": "31727937093689",
  "VF3-9010": "31727937126457",
  "VF3-9016": "31727937159225",
  "VF3-TB": "31727936831545",
  "VF3-TBA": "31727937191993",
  "VF325-7016": "31725719715897",
  "VF325-7021": "31725719748665",
  "VF325-7022": "31725719781433",
  "VF325-7035": "31725719814201",
  "VF325-7036": "31725719846969",
  "VF325-7037": "31725719879737",
  "VF325-9005": "31725719683129",
  "VF325-9006": "31725719912505",
  "VF325-9010": "31725719945273",
  "VF325-9016": "31725719978041",
  "VF325-TB": "31725719650361",
  "VF325-TBA": "31725720010809",
  "VF4-7016": "31727937290297",
  "VF4-7021": "31727937323065",
  "VF4-7022": "31727937355833",
  "VF4-7035": "31727937388601",
  "VF4-7036": "31727937421369",
  "VF4-7037": "31727937454137",
  "VF4-9005": "31727937257529",
  "VF4-9006": "31727937486905",
  "VF4-9010": "31727937519673",
  "VF4-9016": "31727937552441",
  "VF4-TB": "31727937224761",
  "VF4-TBA": "31727937585209",
  "VF450-7016": "31725720109113",
  "VF450-7021": "31725720141881",
  "VF450-7022": "31725720174649",
  "VF450-7035": "31725720207417",
  "VF450-7036": "31725720272953",
  "VF450-7037": "31725720305721",
  "VF450-9005": "31725720076345",
  "VF450-9006": "31725720338489",
  "VF450-9010": "31725720371257",
  "VF450-9016": "31725720404025",
  "VF450-TB": "31725720043577",
  "VF450-TBA": "31725720436793",
  "VF5-7016": "31727937683513",
  "VF5-7021": "31727937716281",
  "VF5-7022": "31727937749049",
  "VF5-7035": "31727937781817",
  "VF5-7036": "31727937814585",
  "VF5-7037": "31727937847353",
  "VF5-9005": "31727937650745",
  "VF5-9006": "31727937880121",
  "VF5-9010": "31727937912889",
  "VF5-9016": "31727937945657",
  "VF5-TB": "31727937617977",
  "VF5-TBA": "31727937978425",
  "VF6-7016": "31728020979769",
  "VF6-7021": "31728021012537",
  "VF6-7022": "31728021045305",
  "VF6-7035": "31728021078073",
  "VF6-7036": "31728021110841",
  "VF6-7037": "31728021143609",
  "VF6-9005": "31728020947001",
  "VF6-9006": "31728021176377",
  "VF6-9010": "31728021241913",
  "VF6-9016": "31728021274681",
  "VF6-TB": "31728020914233",
  "VF6-TBA": "31728021307449",
  "VF7-7016": "31728021405753",
  "VF7-7021": "31728021438521",
  "VF7-7022": "31728021471289",
  "VF7-7035": "31728021504057",
  "VF7-7036": "31728021536825",
  "VF7-7037": "31728021569593",
  "VF7-9005": "31728021372985",
  "VF7-9006": "31728021602361",
  "VF7-9010": "31728021635129",
  "VF7-9016": "31728021667897",
  "VF7-TB": "31728021340217",
  "VF7-TBA": "31728021700665",
});

/* ============================================================
   PRODUCT DATA (all three tools combined)
   ============================================================ */
const AG_PRODUCTS = {
  /* ---- GUTTER SYSTEMS ---- */
  gutter: {
    "Half Round": {
      "Gutter Lengths":        { code:"GHR1",  desc:"HALF ROUND GUTTER LENGTH - 125MM X 3MTR" },
      "Gutter Jointers":       { code:"GHR2",  desc:"HALF ROUND GUTTER JOINTER - 125MM" },
      "Fascia Brackets":       { code:"GHR3",  desc:"HALF ROUND GUTTER FASCIA BRACKET - 125MM" },
      "Side Rafter Arms":      { code:"GHR4",  desc:"HALF ROUND SIDE RAFTER BRACKET - 125MM" },
      "Top Rafter Arms":       { code:"GHR5",  desc:"HALF ROUND TOP RAFTER BRACKET - 125MM" },
      "Rise and Fall Brackets":{ code:"GHR12", desc:"HALF ROUND RISE AND FALL BRACKET" },
      "90° Angles":            { code:"GHR6",  desc:"HALF ROUND GUTTER ANGLE 90 DEG - 125MM" },
      "135° Angles":           { code:"GHR7",  desc:"HALF ROUND GUTTER ANGLE 135 DEG - 125MM" },
      "63mm Dia Outlets":      { code:"GHR8",  desc:"HALF ROUND GUTTER OUTLET 63MM DIA - 125MM" },
      "76mm Dia Outlets":      { code:"GHR9",  desc:"HALF ROUND GUTTER OUTLET 76MM DIA - 125MM" },
      "Stop Ends":             { code:"GHR10", desc:"HALF ROUND GUTTER STOP END - 125MM" }
    },
    "Deepflow": {
      "Gutter Lengths":        { code:"GD1",  desc:"DEEPFLOW GUTTER LENGTH - 130MM - 3MTR" },
      "Gutter Jointers":       { code:"GD2",  desc:"DEEPFLOW GUTTER JOINTER - 130MM" },
      "Fascia Brackets":       { code:"GD3",  desc:"DEEPFLOW GUTTER FASCIA BRACKET - 130MM" },
      "Side Rafter Arms":      { code:"GD4",  desc:"DEEPFLOW GUTTER SIDE RAFTER BRACKET - 130MM" },
      "Top Rafter Arms":       { code:"GD5",  desc:"DEEPFLOW GUTTER TOP RAFTER BRACKET - 130MM" },
      "Rise and Fall Brackets":{ code:"GD12", desc:"DEEPFLOW RISE AND FALL BRACKET" },
      "90° Angles":            { code:"GD6",  desc:"DEEPFLOW GUTTER ANGLE 90 DEG - 130MM" },
      "135° Angles":           { code:"GD7",  desc:"DEEPFLOW GUTTER ANGLE 135 DEG - 130MM" },
      "63mm Dia Outlets":      { code:"GD8",  desc:"DEEPFLOW GUTTER OUTLET 63MM DIA - 130MM" },
      "76mm Dia Outlets":      { code:"GD9",  desc:"DEEPFLOW GUTTER OUTLET 76MM DIA - 130MM" },
      "Stop Ends":             { code:"GD10", desc:"DEEPFLOW GUTTER STOP END - 130MM" }
    },
    "Box": {
      "Gutter Lengths": { code:"GB1",  desc:"BOX GUTTER LENGTH - 135X100MM X 3MTR" },
      "Gutter Jointers":{ code:"GB2",  desc:"BOX GUTTER JOINTER - 135X100MM" },
      "Directly Fixed": { code:"",    desc:"" },
      "90° Angles":     { code:"GB6",  desc:"BOX GUTTER ANGLE 90 DEG - 135X100MM" },
      "135° Angles":    { code:"GB7",  desc:"BOX GUTTER ANGLE 135 DEG - 135X100MM" },
      "63mm Dia Outlets":  { code:"GB8",  desc:"BOX GUTTER OUTLET 63MM DIA - 135X100MM" },
      "76mm Dia Outlets":  { code:"GB9",  desc:"BOX GUTTER OUTLET 76MM DIA - 135X100MM" },
      "72x72mm Outlets":   { code:"GB10", desc:"BOX GUTTER OUTLET 72X72MM - 135X100MM" },
      "Stop Ends":         { code:"GB11", desc:"BOX GUTTER STOP END - 135X100MM" }
    },
    "Moulded Ogee": {
      "Gutter Lengths":         { code:"GTM1",  desc:"MOULDED GUTTER LENGTH - 125x100MM - 1.83MTR" },
      "Gutter Jointers":        { code:"GTM2",  desc:"MOULDED GUTTER JOINTER - 125MM" },
      "Fascia Brackets":        { code:"GTM3",  desc:"MOULDED GUTTER FASCIA BRACKET - 125MM" },
      "Directly Fixed":         { code:"GTM4",  desc:"MOULDED GUTTER DIRECT FIX FASCIA BRACKET - 125MM" },
      "Side Rafter Arms":       { code:"GTM5",  desc:"MOULDED GUTTER SIDE RAFTER BRACKET - 125MM" },
      "Top Rafter Arms":        { code:"GTM6",  desc:"MOULDED GUTTER TOP RAFTER BRACKET - 125MM" },
      "Rise and Fall Brackets": { code:"GTM16", desc:"MOULDED GUTTER RISE AND FALL BRACKET" },
      "90° External Angles":    { code:"GTM7",  desc:"MOULDED GUTTER EXTERNAL ANGLE 90 DEG - 125MM" },
      "90° Internal Angles":    { code:"GTM8",  desc:"MOULDED GUTTER INTERNAL ANGLE 90 DEG - 125MM" },
      "135° External Angles":   { code:"GTM9",  desc:"MOULDED GUTTER EXTERNAL ANGLE 135 DEG - 125MM" },
      "135° Internal Angles":   { code:"GTM10", desc:"MOULDED GUTTER INTERNAL ANGLE 135 DEG - 125MM" },
      "63mm Dia Outlets":       { code:"GTM11", desc:"MOULDED GUTTER OUTLET 63MM DIA - 125MM" },
      "76mm Dia Outlets":       { code:"GTM12", desc:"MOULDED GUTTER OUTLET 76MM DIA - 125MM" },
      "72x72mm Outlets":        { code:"GTM13", desc:"MOULDED GUTTER OUTLET 72X72MM" },
      "L/Hand Stop Ends":       { code:"GTM14", desc:"MOULDED GUTTER LEFT HAND STOP END - 125MM" },
      "R/Hand Stop Ends":       { code:"GTM15", desc:"MOULDED GUTTER RIGHT HAND STOP END - 125MM" }
    }
  },
  /* ---- DOWNPIPE SYSTEMS ---- */
  downpipe: {
    "Flush Joint 63mm dia": {
      "Downpipe Lengths":           { code:"DF631",  desc:"FLUSH JOINT PIPE LENGTH 63MM DIA - 3MTR" },
      "Downpipe Clips":             { code:"DF632",  desc:"DOWNPIPE CLIP 63MM DIA" },
      "Adjustable Downpipe Clips":  { code:"DF633",  desc:"ADJUSTABLE PIPE CLIP 63MM DIA" },
      "Offset Swanneck 80-250mm":   { code:"DF6352", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 63MM - 250MM" },
      "Offset Swanneck 80-500mm":   { code:"DF6355", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 63MM - 500MM" },
      "Offset Swanneck 80-1000mm":  { code:"DF6351", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 63MM - 1000MM" },
      "Downpipe Bends 92.5°":       { code:"DF636",  desc:"FLUSH JOINT BEND 63MM DIA - 92.5 DEG" },
      "Downpipe Bends 112.5°":      { code:"DF637",  desc:"FLUSH JOINT BEND 63MM DIA - 112.5 DEG" },
      "Downpipe Branches 92.5°":    { code:"DF638",  desc:"FLUSH JOINT BRANCH 63MM DIA - 92.5 DEG" },
      "Downpipe Branches 112.5°":   { code:"DF639",  desc:"FLUSH JOINT BRANCH 63MM DIA - 112.5 DEG" },
      "Access Plates":              { code:"DF6310", desc:"DOWNPIPE ACCESS PLATE 63MM" },
      "Shoes":                      { code:"DF6311", desc:"FLUSH JOINT SHOE 63MM DIA" },
      "Hopper Heads":               { code:"DF6312", desc:"HOPPER HEAD 63MM DIA - 300x250x200MM" }
    },
    "Flush Joint 76mm dia": {
      "Downpipe Lengths":          { code:"DF761",  desc:"FLUSH JOINT PIPE LENGTH 76MM DIA - 3MTR" },
      "Downpipe Clips":            { code:"DF762",  desc:"DOWNPIPE CLIP 76MM DIA" },
      "Adjustable Downpipe Clips": { code:"DF763",  desc:"ADJUSTABLE PIPE CLIP 76MM DIA" },
      "Offset Swanneck 90-250mm":  { code:"DF7652", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 76MM - 250MM" },
      "Offset Swanneck 90-500mm":  { code:"DF7655", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 76MM - 500MM" },
      "Offset Swanneck 90-1000mm": { code:"DF7651", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 76MM - 1000MM" },
      "Downpipe Bends 92.5°":      { code:"DF766",  desc:"FLUSH JOINT BEND 76MM DIA - 92.5 DEG" },
      "Downpipe Bends 112.5°":     { code:"DF767",  desc:"FLUSH JOINT BEND 76MM DIA - 112.5 DEG" },
      "Downpipe Branches 92.5°":   { code:"DF768",  desc:"FLUSH JOINT BRANCH 76MM DIA - 92.5 DEG" },
      "Downpipe Branches 112.5°":  { code:"DF769",  desc:"FLUSH JOINT BRANCH 76MM DIA - 112.5 DEG" },
      "Access Plates":             { code:"DF7610", desc:"DOWNPIPE ACCESS PLATE 76MM" },
      "Shoes":                     { code:"DF7611", desc:"FLUSH JOINT SHOE 76MM DIA" },
      "Hopper Heads":              { code:"DF7612", desc:"HOPPER HEAD 76MM DIA - 300x250x200MM" }
    },
    "Flush Joint 72x72mm sq": {
      "Downpipe Lengths":           { code:"DF721",  desc:"FLUSH JOINT PIPE LENGTH 72X72MM SQ - 3MTR" },
      "Downpipe Clips":             { code:"DF722",  desc:"DOWNPIPE CLIP 72X72MM SQ" },
      "Adjustable Downpipe Clips":  { code:"DF723",  desc:"ADJUSTABLE PIPE CLIP 72X72MM SQ" },
      "Offset Swanneck 100-250mm":  { code:"DF7252", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 72X72MM - 250MM" },
      "Offset Swanneck 100-500mm":  { code:"DF7255", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 72X72MM - 500MM" },
      "Offset Swanneck 100-1000mm": { code:"DF7251", desc:"FLUSH JOINT ADJ. OFFSET SWANNECK 72X72MM - 1000MM" },
      "Downpipe Bends 92.5°":       { code:"DF726",  desc:"FLUSH JOINT BEND 72X72MM SQ - 92.5 DEG" },
      "Downpipe Bends 112.5°":      { code:"DF727",  desc:"FLUSH JOINT BEND 72X72MM SQ - 112.5 DEG" },
      "Downpipe Branches 92.5°":    { code:"DF728",  desc:"FLUSH JOINT BRANCH 72X72MM SQ - 92.5 DEG" },
      "Downpipe Branches 112.5°":   { code:"DF729",  desc:"FLUSH JOINT BRANCH 72X72MM SQ - 112.5 DEG" },
      "Access Plates":              { code:"DF7210", desc:"DOWNPIPE ACCESS PLATE 72X72MM SQ" },
      "Shoes":                      { code:"DF7211", desc:"FLUSH JOINT SHOE 72X72MM SQ" },
      "Hopper Heads":               { code:"DF7212", desc:"HOPPER HEAD 72X72MM SQ - 300x250x200MM" }
    },
    "Traditional 63mm dia": {
      "Downpipe Lengths":           { code:"DT631",  desc:"TRADITIONAL PIPE LENGTH 63MM DIA - 3MTR" },
      "Downpipe Clips":             { code:"DF632",  desc:"DOWNPIPE CLIP 63MM DIA" },
      "Adjustable Downpipe Clips":  { code:"DF633",  desc:"ADJUSTABLE PIPE CLIP 63MM DIA" },
      "Offset Swanneck 80-250mm":   { code:"DT6352", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 63MM - 250MM" },
      "Offset Swanneck 80-500mm":   { code:"DT6355", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 63MM - 500MM" },
      "Offset Swanneck 80-1000mm":  { code:"DT6351", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 63MM - 1000MM" },
      "Downpipe Bends 92.5°":       { code:"DT636",  desc:"TRADITIONAL BEND 63MM DIA - 92.5 DEG" },
      "Downpipe Bends 112.5°":      { code:"DT637",  desc:"TRADITIONAL BEND 63MM DIA - 112.5 DEG" },
      "Downpipe Branches 92.5°":    { code:"DT638",  desc:"TRADITIONAL BRANCH 63MM DIA - 92.5 DEG" },
      "Downpipe Branches 112.5°":   { code:"DT639",  desc:"TRADITIONAL BRANCH 63MM DIA - 112.5 DEG" },
      "Access Plates":              { code:"DT6310", desc:"DOWNPIPE ACCESS PLATE 63MM" },
      "Shoes":                      { code:"DT6311", desc:"TRADITIONAL SHOE 63MM DIA" },
      "Hopper Heads":               { code:"DT6312", desc:"HOPPER HEAD 63MM DIA - 300x250x200MM" }
    },
    "Traditional 76mm dia": {
      "Downpipe Lengths":          { code:"DT761",  desc:"TRADITIONAL PIPE LENGTH 76MM DIA - 3MTR" },
      "Downpipe Clips":            { code:"DF762",  desc:"DOWNPIPE CLIP 76MM DIA" },
      "Adjustable Downpipe Clips": { code:"DF763",  desc:"ADJUSTABLE PIPE CLIP 76MM DIA" },
      "Offset Swanneck 90-250mm":  { code:"DT7652", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 76MM - 250MM" },
      "Offset Swanneck 90-500mm":  { code:"DT7655", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 76MM - 500MM" },
      "Offset Swanneck 90-1000mm": { code:"DT7651", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 76MM - 1000MM" },
      "Downpipe Bends 92.5°":      { code:"DT766",  desc:"TRADITIONAL BEND 76MM DIA - 92.5 DEG" },
      "Downpipe Bends 112.5°":     { code:"DT767",  desc:"TRADITIONAL BEND 76MM DIA - 112.5 DEG" },
      "Downpipe Branches 92.5°":   { code:"DT768",  desc:"TRADITIONAL BRANCH 76MM DIA - 92.5 DEG" },
      "Downpipe Branches 112.5°":  { code:"DT769",  desc:"TRADITIONAL BRANCH 76MM DIA - 112.5 DEG" },
      "Access Plates":             { code:"DT7610", desc:"DOWNPIPE ACCESS PLATE 76MM" },
      "Shoes":                     { code:"DT7611", desc:"TRADITIONAL SHOE 76MM DIA" },
      "Hopper Heads":              { code:"DT7612", desc:"HOPPER HEAD 76MM DIA - 300x250x200MM" }
    },
    "Traditional 72x72mm sq": {
      "Downpipe Lengths":           { code:"DT721",  desc:"TRADITIONAL PIPE LENGTH 72X72MM SQ - 3MTR" },
      "Downpipe Clips":             { code:"DF722",  desc:"DOWNPIPE CLIP 72X72MM SQ" },
      "Adjustable Downpipe Clips":  { code:"DF723",  desc:"ADJUSTABLE PIPE CLIP 72X72MM SQ" },
      "Offset Swanneck 100-250mm":  { code:"DT7252", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 72X72MM - 250MM" },
      "Offset Swanneck 100-500mm":  { code:"DT7255", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 72X72MM - 500MM" },
      "Offset Swanneck 100-1000mm": { code:"DT7251", desc:"TRADITIONAL ADJ. OFFSET SWANNECK 72X72MM - 1000MM" },
      "Downpipe Bends 92.5°":       { code:"DT726",  desc:"TRADITIONAL BEND 72X72MM SQ - 92.5 DEG" },
      "Downpipe Bends 112.5°":      { code:"DT727",  desc:"TRADITIONAL BEND 72X72MM SQ - 112.5 DEG" },
      "Downpipe Branches 92.5°":    { code:"DT728",  desc:"TRADITIONAL BRANCH 72X72MM SQ - 92.5 DEG" },
      "Downpipe Branches 112.5°":   { code:"DT729",  desc:"TRADITIONAL BRANCH 72X72MM SQ - 112.5 DEG" },
      "Access Plates":              { code:"DT7210", desc:"DOWNPIPE ACCESS PLATE 72X72MM SQ" },
      "Shoes":                      { code:"DT7211", desc:"TRADITIONAL SHOE 72X72MM SQ" },
      "Hopper Heads":               { code:"DT7212", desc:"HOPPER HEAD 72X72MM SQ - 300x250x200MM" }
    }
  },
  /* ---- FASCIA SYSTEMS ---- */
  fascia: {
    "L Return": {
      "Fascia Boards": { 150:{ code:"LF150",desc:"L RETURN FASCIA BOARD (30mm Return) / 150MM - 3M" }, 210:{ code:"LF210",desc:"L RETURN FASCIA BOARD (30mm Return) / 210MM - 3M" }, 335:{ code:"LF335",desc:"L RETURN FASCIA BOARD (30mm Return) / 335MM - 3M" }, 460:{ code:"LF460",desc:"L RETURN FASCIA BOARD (30mm Return) / 460MM - 3M" } },
      "Fascia Joint Covers":   { code:"LF1", desc:"L FASCIA BOARD JOINT COVER (500MM)" },
      "External 90° Corners":  { code:"LF2", desc:"L RETURN FASCIA BOARD ANGLE - 90 DEG EXTERNAL" },
      "Internal 90° Corners":  { code:"LF3", desc:"L RETURN FASCIA BOARD ANGLE - 90 DEG INTERNAL" },
      "External 135° Corners": { code:"LF4", desc:"L RETURN FASCIA BOARD ANGLE - 135 DEG EXTERNAL" },
      "Internal 135° Corners": { code:"LF5", desc:"L RETURN FASCIA BOARD ANGLE - 135 DEG INTERNAL" },
      "Gable Box End Sections":{ code:"LF7", desc:"L RETURN FASCIA BOARD GABLE BOX END (650x600MM)" }
    },
    "V Return": {
      "Fascia Boards": { 165:{ code:"VF165",desc:"V RETURN FASCIA BOARD (30mm Return, 45°) / 165MM - 3M" }, 250:{ code:"VF250",desc:"V RETURN FASCIA BOARD (30mm Return, 45°) / 250MM - 3M" }, 325:{ code:"VF325",desc:"V RETURN FASCIA BOARD (30mm Return, 45°) / 325MM - 3M" }, 450:{ code:"VF450",desc:"V RETURN FASCIA BOARD (30mm Return, 45°) / 450MM - 3M" } },
      "Fascia Joint Covers":   { code:"VF1", desc:"V FASCIA BOARD JOINT COVER (500MM)" },
      "External 90° Corners":  { code:"VF2", desc:"V RETURN FASCIA BOARD ANGLE - 90 DEG EXTERNAL" },
      "Internal 90° Corners":  { code:"VF3", desc:"V RETURN FASCIA BOARD ANGLE - 90 DEG INTERNAL" },
      "External 135° Corners": { code:"VF4", desc:"V RETURN FASCIA BOARD ANGLE - 135 DEG EXTERNAL" },
      "Internal 135° Corners": { code:"VF5", desc:"V RETURN FASCIA BOARD ANGLE - 135 DEG INTERNAL" },
      "Gable Box End Sections":{ code:"VF7", desc:"V RETURN FASCIA BOARD GABLE BOX END (650x600MM)" }
    },
    "U Return": {
      "Fascia Boards": { 150:{ code:"UF150",desc:"U RETURN FASCIA BOARD (30x25mm Return) / 150MM - 3M" }, 235:{ code:"UF235",desc:"U RETURN FASCIA BOARD (30x25mm Return) / 235MM - 3M" }, 310:{ code:"UF310",desc:"U RETURN FASCIA BOARD (30x25mm Return) / 310MM - 3M" }, 435:{ code:"UF435",desc:"U RETURN FASCIA BOARD (30x25mm Return) / 435MM - 3M" } },
      "Fascia Joint Covers":   { code:"UF1", desc:"U FASCIA BOARD JOINT COVER (500MM)" },
      "External 90° Corners":  { code:"UF2", desc:"U RETURN FASCIA BOARD ANGLE - 90 DEG EXTERNAL" },
      "Internal 90° Corners":  { code:"UF3", desc:"U RETURN FASCIA BOARD ANGLE - 90 DEG INTERNAL" },
      "External 135° Corners": { code:"UF4", desc:"U RETURN FASCIA BOARD ANGLE - 135 DEG EXTERNAL" },
      "Internal 135° Corners": { code:"UF5", desc:"U RETURN FASCIA BOARD ANGLE - 135 DEG INTERNAL" },
      "Gable Box End Sections":{ code:"UF7", desc:"U RETURN FASCIA BOARD GABLE BOX END (650x600MM)" }
    }
  },
  soffit: {
    "Unvented": {
      "Soffit Boards": { 180:{code:"SF180",desc:"SOFFIT BOARD UNVENTED / 180MM WIDE - 3M"}, 365:{code:"SF365",desc:"SOFFIT BOARD UNVENTED / 365MM WIDE - 3M"}, 490:{code:"SF490",desc:"SOFFIT BOARD UNVENTED / 490MM WIDE - 3M"}, 740:{code:"SF740",desc:"SOFFIT BOARD UNVENTED / 740MM WIDE - 3M"} },
      "Soffit Joint Covers": { "SF1":{code:"SF1",desc:"SOFFIT BOARD JOINT COVER (500MM)"}, "SF2":{code:"SF2",desc:"SOFFIT BOARD JOINT COVER (1000MM)"} }
    },
    "Vented": {
      "Soffit Boards": { 180:{code:"SV180",desc:"SOFFIT BOARD VENTED / 180MM WIDE - 3M"}, 365:{code:"SV365",desc:"SOFFIT BOARD VENTED / 365MM WIDE - 3M"}, 490:{code:"SV490",desc:"SOFFIT BOARD VENTED / 490MM WIDE - 3M"}, 740:{code:"SV740",desc:"SOFFIT BOARD VENTED / 740MM WIDE - 3M"} },
      "Soffit Joint Covers": { "SF1":{code:"SF1",desc:"SOFFIT BOARD JOINT COVER (500MM)"}, "SF2":{code:"SF2",desc:"SOFFIT BOARD JOINT COVER (1000MM)"} }
    }
  },
  /* ---- COPING SYSTEMS ---- */
  coping: {
    "C175": { min:115, max:175, "Coping Lengths":{code:"C175",desc:"ALUMINIUM COPING LENGTH (115-175mm WALL WIDTH) - 3M"}, "Coping Brackets/Jointers":{code:"C1751",desc:"ALUMINIUM COPING FIXING/JOINT BRACKETS"}, "90° Corners":{code:"C1752",desc:"ALUMINIUM COPING ANGLES - 90 DEG"}, "T-Junctions":{code:"C1753",desc:"ALUMINIUM COPING 'T' JUNCTION"}, "Stop Ends":{code:"C1754",desc:"ALUMINIUM COPING STOP END"}, "Stop End Upstands":{code:"C1755",desc:"ALUMINIUM COPING STOP END UPSTAND"} },
    "C240": { min:176, max:240, "Coping Lengths":{code:"C240",desc:"ALUMINIUM COPING LENGTH (176-240mm WALL WIDTH) - 3M"}, "Coping Brackets/Jointers":{code:"C2401",desc:"ALUMINIUM COPING FIXING/JOINT BRACKETS"}, "90° Corners":{code:"C2402",desc:"ALUMINIUM COPING ANGLES - 90 DEG"}, "T-Junctions":{code:"C2403",desc:"ALUMINIUM COPING 'T' JUNCTION"}, "Stop Ends":{code:"C2404",desc:"ALUMINIUM COPING STOP END"}, "Stop End Upstands":{code:"C2405",desc:"ALUMINIUM COPING STOP END UPSTAND"} },
    "C300": { min:241, max:300, "Coping Lengths":{code:"C300",desc:"ALUMINIUM COPING LENGTH (241-300mm WALL WIDTH) - 3M"}, "Coping Brackets/Jointers":{code:"C3001",desc:"ALUMINIUM COPING FIXING/JOINT BRACKETS"}, "90° Corners":{code:"C3002",desc:"ALUMINIUM COPING ANGLES - 90 DEG"}, "T-Junctions":{code:"C3003",desc:"ALUMINIUM COPING 'T' JUNCTION"}, "Stop Ends":{code:"C3004",desc:"ALUMINIUM COPING STOP END"}, "Stop End Upstands":{code:"C3005",desc:"ALUMINIUM COPING STOP END UPSTAND"} },
    "C360": { min:301, max:360, "Coping Lengths":{code:"C360",desc:"ALUMINIUM COPING LENGTH (301-360mm WALL WIDTH) - 3M"}, "Coping Brackets/Jointers":{code:"C3601",desc:"ALUMINIUM COPING FIXING/JOINT BRACKETS"}, "90° Corners":{code:"C3602",desc:"ALUMINIUM COPING ANGLES - 90 DEG"}, "T-Junctions":{code:"C3603",desc:"ALUMINIUM COPING 'T' JUNCTION"}, "Stop Ends":{code:"C3604",desc:"ALUMINIUM COPING STOP END"}, "Stop End Upstands":{code:"C3605",desc:"ALUMINIUM COPING STOP END UPSTAND"} },
    "C420": { min:361, max:420, "Coping Lengths":{code:"C420",desc:"ALUMINIUM COPING LENGTH (361-420mm WALL WIDTH) - 3M"}, "Coping Brackets/Jointers":{code:"C4201",desc:"ALUMINIUM COPING FIXING/JOINT BRACKETS"}, "90° Corners":{code:"C4202",desc:"ALUMINIUM COPING ANGLES - 90 DEG"}, "T-Junctions":{code:"C4203",desc:"ALUMINIUM COPING 'T' JUNCTION"}, "Stop Ends":{code:"C4204",desc:"ALUMINIUM COPING STOP END"}, "Stop End Upstands":{code:"C4205",desc:"ALUMINIUM COPING STOP END UPSTAND"} }
  },
  /* ---- SUNDRY ---- */
  sundry: {
    "Low Modulus Silicone Sealant":            { code:"SU1",  desc:"TUBE OF LOW MODULUS SILICONE SEALANT (380ml)" },
    "Gutter Bracket Fixing Screws":            { code:"SU3",  desc:"GUTTER BRACKET FIXING SCREWS (QTY 100)" },
    "Moulded Gutter Fixing Screws":            { code:"SU4",  desc:"MOULDED GUTTER FIXING SCREWS (QTY 100)" },
    "Moulded Gutter M6 Joint Nut & Bolt Set":  { code:"SU5",  desc:"MOULDED GUTTER M6 JOINT NUT, BOLT AND WASHER SET (QTY 100)" },
    "Touch Up Paint":                          { code:"SU6",  desc:"TOUCH UP PAINT (125ml)" },
    "Pipe Fixing Screws":                      { code:"SU9",  desc:"PIPE FIXING SCREWS (QTY 50)" },
    "Box Gutter Fixing Screws & Washers":      { code:"SU10", desc:"BOX GUTTER FIXING SCREWS & WASHERS (QTY 100)" },
    "Fascia Fixing Screws":                    { code:"SU7",  desc:"FASCIA/SOFFIT COLOUR MATCHED FIXING SCREW (Qty 100) - No. 8 x 15mm" },
    "Coping Bracket Fixing Screws":            { code:"SU11", desc:"COPING BRACKET FIXING SCREW (Qty 100) - No. 10 x 24mm" }
  }
};
